
let scene, camera, renderer, controls, model, modelGroup;
let isUserInteracting = false;
let autoRotateTimeout = null;
let originalMaterials = [];
let isTransparent = false;
let isWireframe = false;
const wireframeOutlines = [];1
let isFlat = false;
let isDark = false;
let isStats = false;
let isInfo = false;
let isFacesRun = false;
let isFaces = false;
let isAutorotate = true;
let isLight = false;

/* Селективный bloom для светящихся материалов (линза/лента).
   Слой 2 видят и обычная камера, и bloom-проход; остальные меши на время
   bloom-прохода красятся в чёрный, поэтому ореол получает только сам
   светильник, а не белые панели и блики. */
const BLOOM_LAYER = 2;
const BLOOM_STRENGTH = 0.8;
const BLOOM_RADIUS = 0.45;
const BLOOM_THRESHOLD = 0.25;
const LED_EMISSIVE_ON = 2.2;    // сама лента — мягкое свечение
const LED_LENS_ON = 0.5;        // молочная линза не должна выжигать кадр
const LED_EMISSIVE_OFF = 0.15;
let __bloom = null;

// === X-Ray Lighting Functions ===
let defaultLights = [];
let defaultEnvironment = null;

function toggleXRayLighting() {
  // Сохраняем стандартные источники света и окружение (только один раз)
  if (defaultLights.length === 0) {
    scene.children.forEach(obj => {
      if (obj.isLight) defaultLights.push(obj);
    });
    defaultEnvironment = scene.environment;
  }
  // Удаляем все источники света
  scene.children = scene.children.filter(obj => !obj.isLight);
  // Удаляем окружение
  scene.environment = null;
  // Добавляем только один мягкий DirectionalLight
  const xrayLight = new THREE.DirectionalLight(0xffffff, 1.2);
  xrayLight.position.set(-3, 5, 5);
  scene.add(xrayLight);
}

function restoreDefaultLighting() {
  // Удаляем все текущие источники света
  scene.children = scene.children.filter(obj => !obj.isLight);
  // Восстанавливаем стандартные источники света
  defaultLights.forEach(light => scene.add(light));
  // Восстанавливаем окружение
  scene.environment = defaultEnvironment;
}

function init() {
  scene = new THREE.Scene();
  camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 0.1, 100);
  camera.position.set(0, 1.5, 3);

  renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true }); // alpha: true для прозрачности
  renderer.setClearColor(0x000000, 0); // Прозрачный фон
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMappingExposure = 1.0;
  renderer.sortObjects = true;
  //renderer.localClippingEnabled = true;
  
  document.getElementById('container').appendChild(renderer.domElement);

  // Light
  //ambientLight = new THREE.AmbientLight( 0x7c7c7c, 2.0 );
  //scene.add( ambientLight );
  const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444, 0.55);  // r180: старые 0.175 × π
  hemiLight.position.set(0, 12, 0);
  scene.add(hemiLight);
  const dirLight = new THREE.DirectionalLight(0xffffff, 0.55);
  dirLight.position.set(3, 10, 10);
  scene.add(dirLight);
  // Дополнительный источник света перед, выше и левее модели
  const frontLeftLight = new THREE.DirectionalLight(0xffffff, 0.47);
  frontLeftLight.position.set(-3, -3, 4);
  scene.add(frontLeftLight);

  //const lightHelper = new THREE.DirectionalLightHelper(dirLight);
  //scene.add(lightHelper);

  // OrbitControls приходит из boot.js (three 0.180), CDN-загрузку убрали:
  // старый r132-контроллер несовместим с новым ядром
  {
    controls = new THREE.OrbitControls(camera, renderer.domElement);
    controls.target.set(0, 0, 0);
    controls.enableDamping = true;
    controls.dampingFactor = 0.3;
    controls.autoRotateSpeed = 0.25;
    controls.minDistance = 0.1;
    controls.maxDistance = 10;
    controls.update();
    controls.addEventListener('start', function() {
      controls.autoRotate = false;
    });
    controls.addEventListener('end', function() {
      controls.autoRotate = false;
      setTimeout(function() {
        controls.autoRotate = isAutorotate;
      }, 7000);
    });
    setTimeout(function() {
      controls.autoRotate = isAutorotate;
      /* Сетка больше не привязана к таймеру: она включается сразу после
         того, как модель отрисовалась (см. __autoGrid в конце загрузки).
         Здесь остаётся только авто-вращение. */
    }, 9000);
    animate();
  }

  // Базовое окружение ставим сразу — оно даёт нормальную яркость материалам
  if (window.__makeRoomEnv) {
    try {
      scene.environment = window.__makeRoomEnv(renderer);
    } catch (e) {
      console.warn('[viewer] окружение не создалось:', e.message);
    }
  }

  /* Внешний HDRI убрали: polyhaven не отдаётся (CORS/404), three на этом
     падает непойманным исключением, а старт вьювера затягивается на таймаут.
     Окружение даёт RoomEnvironment — от внешнего файла картинка не зависит. */
}

async function loadModelFromServer(url) {
try {
  showBusyAlert('Загружаем модель...');
setTimeout(() => addAlert('Модель слишком большая, необходимо больше времени. Продолжаем загрузку...'), 7000);
// 1. Загружаем файл с сервера
const response = await fetch(url);
if (!response.ok) {
  throw new Error('файл не найден на сервере: ' + response.status + ' ' + response.statusText);
}
const arrayBuffer = await response.arrayBuffer();

/* Определяем, что именно пришло. Раньше файл безусловно отдавался
   GLTFLoader, и любой не-GLB (OBJ, .gltf, HTML-страница ошибки) валился
   сообщением про JSON. */
const magic = arrayBuffer.byteLength >= 4 ? new DataView(arrayBuffer).getUint32(0, true) : 0;
const isGLB = (magic === 0x46546C67);          /* 'glTF' */
let headText = '';
try {
  headText = new TextDecoder().decode(new Uint8Array(arrayBuffer, 0, Math.min(512, arrayBuffer.byteLength))).trim();
} catch (eHead) { headText = ''; }

const finish = function(sceneRoot, gltfLike) {
  const gltf = gltfLike || { animations: [] };
  model = sceneRoot;
  __basisFacadeCache = null;   /* имена фасадов пересчитываем для новой модели */

  /* «Полупрозрачный», «Взрыв» и «Поиск детали» работают только с деталями
     Базиса (у них есть partId). OBJ-модель загружается уже конвертированной в
     GLB, поэтому смотрим не на источник файла, а на содержимое сцены. */
  let __partsCount = 0;
  const __seenParts = new Set();
  model.traverse((o) => {
    const pid = o.userData && o.userData.partId;
    if (pid && !__seenParts.has(pid)) { __seenParts.add(pid); __partsCount++; }
  });
  const __hasParts = __partsCount > 0;
  window.__modelHasParts = __hasParts;
  window.__modelPartsCount = __partsCount;
  console.log('[viewer] деталей с partId:', __partsCount);
  if (!__hasParts) {
    const __hidePartsItems = () => {
      ['mnu_alpha', 'mnu_explode', 'mnu_find', 'mnu_hw', 'mnu_prof', 'mnu_light'].forEach((id) => {
        const el = document.getElementById(id);
        if (el) {
          el.classList.add('hidden-field');
          el.style.display = 'none';   /* на случай, если класс снимут позже */
        }
      });
    };
    __hidePartsItems();
    /* повторно — после того как отработают остальные блоки инициализации */
    setTimeout(__hidePartsItems, 300);
    setTimeout(__hidePartsItems, 1500);
    console.log('[viewer] в модели нет деталей Базиса (partId): скрыты «Полупрозрачный», «Взрыв», «Поиск детали»');
  }

  const targetPatterns = ['Fasad1','Fasad2','Fasad3'];

  /* Крепёж → к детали на загрузке (js/app/attach-hw.js): в старых GLB
     фурнитура лежала в корне и при анимации оставалась на месте. */
  try {
    if (typeof window.__attachHardwareToParts === 'function') {
      const movedHw = window.__attachHardwareToParts(model);
      if (movedHw) console.log('[viewer] крепёж привязан к деталям:', movedHw);
    }
  } catch (eHw) {
    console.warn('[viewer] привязка крепежа не удалась:', eHw && eHw.message ? eHw.message : eHw);
  }


  /* Модели из Базиса несут роль детали в userData.role (facade / drawer-front).
     Приводим её к тому признаку, на который рассчитан остальной код ниже,
     чтобы «Скрыть фасады» работало и для них. */
  model.traverse(child => {
    if (!child.isMesh) return;
    const role = child.userData && child.userData.role;
    if (role === 'facade' || role === 'drawer-front') {
      /* только на меше: userData материала общий для всех панелей из одного
         ЛДСП, и по нему «фасадом» становился весь корпус */
      child.userData.fasade = 1;
    }
  });

  model.traverse(child => {
    if (child.isMesh && child.material) {
      const materials = Array.isArray(child.material) ? child.material : [child.material];
      materials.forEach(mat => {
        if (!mat || !mat.name) return;
        const match = targetPatterns.some(p => mat.name.includes(p) || mat.userData.fasade == 1);
        if (match) {
          mat.transparent = false;
          mat.opacity = 1;
          mat.depthWrite = true;
          mat.needsUpdate = true;
          isFacesRun = true;
        }
      });
    }
  });
  
  /* Кнопка «Скрыть фасады» — только если фасады действительно найдены:
     OBJ — материалы Fasad1..3 или MTL «Fasad N»; Базис — детали «Фасад»/«Дверь». */
  try {
    const fasadItem = document.getElementById('mnu_fasad');
    const facFound = __facadesFound();
    if (fasadItem) {
      if (facFound) { fasadItem.classList.remove('hidden-field'); }
      else { fasadItem.classList.add('hidden-field'); }
    }
    if (window.__modelHasParts) {
      const d = __basisFacadeNodes();
      console.log('[facades] фасады в модели:', facFound,
        '| узлов с именем:', d.named, '| деталей-фасадов:', d.nodes.length,
        '| мешей в них:', d.meshes, '| примеры:', JSON.stringify(d.samples));
    } else {
      console.log('[facades] фасады в модели:', facFound, '| (материалы Fasad1..3 / MTL)');
    }
  } catch (eFac) {
    /* ошибка поиска фасадов не должна ломать загрузку модели */
    console.warn('[facades] ошибка поиска фасадов:', eFac);
  }
  // Центрируем модель
  const box = new THREE.Box3().setFromObject(model);
  const center = box.getCenter(new THREE.Vector3());
  model.position.sub(center);
  
  // Добавляем модель в группу и группу в сцену
  modelGroup = new THREE.Group();
  modelGroup.add(model);
  scene.add(modelGroup);
  
  // Сохраняем оригинальные материалы
  model.traverse(child => {
    if (child.isMesh && child.material) {
      originalMaterials.push({
        mesh: child,
        material: child.material
      });
    }
  });
  
  // Теперь, когда исходные материалы сохранены, выключаем прозрачность у фасадов

  fitCameraToObject(camera, model, controls);
  initBasisExtras(gltf);
  __hideOutlines();
  initDimensionsButton();
  initRoomButton();     /* «Комната» — сразу под «Размеры» */

  /* Сетку включаем сами — сразу, как только модель отрисовалась.
     Раньше она появлялась через 9 секунд после загрузки (чтобы не казалось,
     что страница зависла), но это читалось как «модель без сетки». Теперь
     ждём первый кадр с моделью (двойной requestAnimationFrame) и строим
     линии: картинка уже на экране, задержки в 9 секунд нет. */
  const __autoGrid = () => {
    if (!model) return;
    if (__wireMode) return;                    /* пользователь уже включил сетку */
    try {
      __setWireMode('overlay');
      console.log('[viewer] сетка включена автоматически после загрузки модели');
    } catch (eGrid) {
      console.warn('[viewer] сетка не включилась:', eGrid && eGrid.message ? eGrid.message : eGrid);
    }
  };
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(() => requestAnimationFrame(__autoGrid));
  } else {
    setTimeout(__autoGrid, 0);
  }
};

if (isGLB) {
  /* обычный GLB */
  window.__modelSource = 'glb';
  new THREE.GLTFLoader().parse(arrayBuffer, '', function(gltf) {
    finish(gltf.scene, gltf);
  }, function(error) {
    alert('Ошибка загрузки GLB: ' + (error && error.message ? error.message : error));
  });
} else if (headText.charAt(0) === '{') {
  /* .gltf — это JSON, GLTFLoader умеет и его */
  try {
    /* База для внешних .bin/текстур — папка самого файла, иначе GLTFLoader
       ищет ресурсы от корня страницы и получает 404 (HTML → «ошибка JSON»). */
    const basePath = String(url).replace(/[^/]*$/, '');
    new THREE.GLTFLoader().parse(new TextDecoder().decode(arrayBuffer), basePath, function(gltf) {
      finish(gltf.scene, gltf);
    }, function(error) {
      alert('Ошибка загрузки glTF: ' + (error && error.message ? error.message : error));
    });
  } catch (eGltf) {
    alert('Не удалось разобрать glTF: ' + eGltf.message);
  }
} else if (/^\s*(v|vn|vt|f|o|g|usemtl|mtllib)\s/m.test(headText)) {
  /* .obj — соберём сцену сами */
  try {
    const obj = new THREE.OBJLoader().parse(new TextDecoder().decode(arrayBuffer));
    obj.traverse((ch) => {
      if (!ch.isMesh) return;
      const src = ch.material;
      ch.material = new THREE.MeshStandardMaterial({
        color: (src && src.color) ? src.color.clone() : new THREE.Color(0xcccccc),
        map: src && src.map ? src.map : null,
        roughness: 0.85,
        metalness: 0.0,
        side: THREE.DoubleSide
      });
    });
    /* источник модели: для OBJ часть инструментов недоступна */
    window.__modelSource = 'obj';
    finish(obj, { animations: [] });
  } catch (eObj) {
    alert('Не удалось разобрать OBJ: ' + eObj.message);
  }
} else {
  alert('Файл не похож ни на GLB, ни на glTF, ни на OBJ. Первые символы: ' +
        JSON.stringify(headText.slice(0, 40)));
}

} catch (error) {
alert('Ошибка при загрузке файла: ' + error.message);
} finally {
  killAlert(2000);
}
}

function fitCameraToObject(camera, object, controls) {
  const box = new THREE.Box3().setFromObject(object);
  const size = box.getSize(new THREE.Vector3());
  const center = box.getCenter(new THREE.Vector3());
  const maxDim = Math.max(size.x, size.y, size.z);
  const fov = camera.fov * (Math.PI / 180);
  let cameraZ = Math.abs(maxDim / 2 / Math.tan(fov / 2));
  cameraZ *= 1.5;
  camera.position.set(center.x, center.y + maxDim * 0.2, center.z + cameraZ);
  camera.lookAt(center);
  if (controls) {
    controls.target.copy(center);
    controls.update();
  }
}

function animate() {
  requestAnimationFrame(animate);

  /* анимации дверей из GLB: микшер обновляем в общем цикле рендера */
  if (window.__basisMixer) {
    try { window.__basisMixer.update(__basisClock.getDelta()); } catch (e) { console.error('[doors] mixer:', e); }
  }

/*      if (modelGroup && !isUserInteracting) {
    modelGroup.rotation.y += 0.0005; // плавное вращение вокруг оси Y
  }*/
  if (controls) controls.update();

  renderScene();
}

window.addEventListener('resize', () => {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
  __resizeBloom(window.innerWidth, window.innerHeight);
});

// Функция для подмены материала на полупрозрачные
function toggleMaterial() {
  if (!model) return;
  if (isDark) toggleBack();
  isTransparent = !isTransparent;
  if (isTransparent) {
    // Заменяем на полупрозрачный материал
    model.traverse(child => {
      if (child.isMesh) {
          /* // прредложеный вариант ренгена
          const matcapTexture = new THREE.TextureLoader().load('https://raw.githubusercontent.com/nidorx/matcaps/master/1024/888888_FFFFFF_CCCCCC_666666-512px.png');
          child.material = new THREE.MeshMatcapMaterial({
            matcap: matcapTexture,
            transparent: true,
            opacity: 0.3,
            side: THREE.DoubleSide
          });
          */

        child.material = new THREE.MeshBasicMaterial({ 
          color: 0x0a0a0a,
          transparent: true,
          opacity: 0.2,
          depthWrite: false,
          /* side: THREE.DoubleSide !!!! убрали дабл сайд и все перестало тормозить */
          });
        /*
        child.material = new THREE.MeshLambertMaterial( {
          color: 0xffffff,
          opacity: 0.3,
          side: THREE.DoubleSide,
          depthWrite: false,
          transparent: true
        } );*/
        child.material.needsUpdate = true;
      }
    });
    toggleXRayLighting();
    document.getElementById('mnu_rg').classList.add('selected');
  } else {
    // Восстанавливаем оригинальные материалы
    originalMaterials.forEach(obj => {
      obj.mesh.material = obj.material;
      obj.mesh.material.needsUpdate = true;
    });
    restoreDefaultLighting();
    document.getElementById('mnu_rg').classList.remove('selected');
  }
}

// Функция наложения сетки на объкт
/* Поверхности отодвигаем по глубине, чтобы тонкие линии (ребра, контуры)
   не дрались с ними за пиксель. Именно так это сделано у конкурентов:
   polygonOffset на самой ЛИНИИ не работает, а на ГРАНИ — работает. */
const __surfaceBiasSaved = new Map();
function __surfaceBias(on) {
  if (!model) return;
  if (on) {
    model.traverse(o => {
      if (!o.isMesh || !o.material) return;
      const ud = o.userData || {};
      if (!ud.partId && !ud.edge && !ud.plastic) return;
      const list = Array.isArray(o.material) ? o.material : [o.material];
      for (const m of list) {
        if (!m || __surfaceBiasSaved.has(m)) continue;
        __surfaceBiasSaved.set(m, {
          polygonOffset: m.polygonOffset,
          factor: m.polygonOffsetFactor,
          units: m.polygonOffsetUnits
        });
        m.polygonOffset = true;
        m.polygonOffsetFactor = 1;
        m.polygonOffsetUnits = 1;
        m.needsUpdate = true;
      }
    });
  } else {
    __surfaceBiasSaved.forEach((orig, m) => {
      m.polygonOffset = orig.polygonOffset;
      m.polygonOffsetFactor = orig.factor;
      m.polygonOffsetUnits = orig.units;
      m.needsUpdate = true;
    });
    __surfaceBiasSaved.clear();
  }
}

/* --- Сетка: два режима, один и тот же построитель линий ------------------- */
/*  overlay — «Сетка»: линии поверх обычной модели.
    only    — «Сетчатый»: ТОЛЬКО линии, без текстур: меши скрываются, а линии
              переносятся в корень модели, чтобы не скрыться вместе с ними.  */
let __wireMode = null;           /* null | 'overlay' | 'only' */
const __wireItems = [];          /* { line, mesh, restored } */

function __syncWireMenu() {
  const a = document.getElementById('mnu_wire2');   /* «Сетчатый» — только линии */
  const b = document.getElementById('mnu_wf');      /* «Сетка»    — линии поверх  */
  if (a) a.classList.toggle('selected', __wireMode === 'only');
  if (b) b.classList.toggle('selected', __wireMode === 'overlay');
}

function __clearWireframe() {
  for (const it of __wireItems) {
    if (it.mesh) { it.mesh.visible = true; }
    if (it.line && it.line.parent) { it.line.parent.remove(it.line); }
    if (it.line && it.line.geometry) { it.line.geometry.dispose(); }
  }
  __wireItems.length = 0;

  /* контуры деталей не удаляем — просто прячем */
  if (model) {
    model.traverse(ch => { if (ch.userData && ch.userData.outline) { ch.visible = false; } });
  }
  wireframeOutlines.length = 0;
  __wireMode = null;
  __syncWireMenu();
}

/* Сдвиг сетки внутрь периметра детали.
   Линии строятся по границе детали, поэтому на стыках их перекрывает соседняя
   деталь (полка «уходит» в стойку). Сжимаем рёбра к центру ТОЛЬКО по
   «плоскостным» осям — тем, что больше 4× минимального габарита; ось толщины
   не трогаем, иначе линия ушла бы внутрь тела и её закрыла бы собственная
   пласть. Величина сдвига задаётся в миллиметрах, по умолчанию 0.3 мм,
   подстраивается в консоли: window.__wireInset = 0.6 */
const WIRE_INSET_DEFAULT = 0.3;

function __wireInsetScale(box, inset) {
  const sc = new THREE.Vector3(1, 1, 1);
  if (!box || !isFinite(inset) || inset <= 0) return sc;
  const size = new THREE.Vector3();
  box.getSize(size);
  const minDim = Math.max(0.001, Math.min(size.x, size.y, size.z));
  const k = (v) => (v <= minDim * 4 ? 1 : Math.max(0.985, (v - 2 * inset) / v));
  sc.set(k(size.x), k(size.y), k(size.z));
  return sc;
}

function __buildWireframe(opts) {
  const only = !!(opts && opts.only);
  const __insetRaw = Number(window.__wireInset);
  const WIRE_INSET = isFinite(__insetRaw) && __insetRaw >= 0 ? __insetRaw : WIRE_INSET_DEFAULT;
  /* Линии — THREE.LineSegments + LineBasicMaterial. Толщину в WebGL задать
     нельзя: `linewidth` игнорируется, линия всегда 1 пиксель. Поэтому «тоньше»
     делается только контрастом — прозрачностью и светлотой цвета. */
  const mat = new THREE.LineBasicMaterial({
    color: 0x2b3038,
    transparent: true,
    opacity: only ? 0.62 : 0.42,
    depthWrite: false,
    /* в режиме «только сетка» показываем все рёбра без сортировки по глубине */
    depthTest: !only
  });

  const excludedNames = ["Mtl0AE504DE", "Mtl12C382CD", "Mtl18D23820", "Mtl1FC06A2C", "Mtl2A141CA5",
    "Mtl2A811C82", "Mtl2EDEF880", "Mtl33B3C606", "Mtl4255E53B", "Mtl63511A8E", "Mtl6BF4145A"];

  const victims = [];
  model.traverse(child => {
    if (!child.isMesh || !child.material) return;
    const udW = child.userData || {};
    if (udW.edge || udW.plastic) return;

    /* фурнитуру обводим только по верхнему уровню группы */
    let anc = child.parent;
    while (anc && anc !== model) {
      if (anc.userData && anc.userData.hw) { return; }
      anc = anc.parent;
    }

    const materials = Array.isArray(child.material) ? child.material : [child.material];
    if (materials.some(m => excludedNames.some(n => m && m.name && m.name.includes(n)))) return;

    /* панель с вырезом: показываем заранее построенный контур */
    if (child.userData && child.userData.contour) {
      child.children.forEach(ch => {
        if (!ch.userData || !ch.userData.outline) return;
        ch.visible = true;
        ch.renderOrder = 10;

        /* контур сдвигаем так же, но только если его геометрия отцентрована —
           иначе масштаб сместил бы вырез относительно самой детали */
        try {
          if (ch.geometry) {
            ch.geometry.computeBoundingBox();
            const bb = ch.geometry.boundingBox;
            if (bb) {
              const c = bb.getCenter(new THREE.Vector3());
              if (c.length() < 1) { ch.scale.copy(__wireInsetScale(bb, WIRE_INSET)); }
            }
          }
        } catch (eContourScale) {}

        wireframeOutlines.push(ch);
        if (only) {
          child.updateMatrixWorld(true);
          model.attach(ch);                 /* вынимаем из детали, чтобы не скрылось */
          ch.userData.__fromWire = child;
        }
      });
      victims.push(child);
      return;
    }

    const eg = new THREE.EdgesGeometry(child.geometry, 15);
    eg.computeBoundingBox();
    const ec = eg.boundingBox ? eg.boundingBox.getCenter(new THREE.Vector3()) : new THREE.Vector3();
    eg.translate(-ec.x, -ec.y, -ec.z);

    const line = new THREE.LineSegments(eg, mat);
    line.position.copy(ec);
    /* сдвиг внутрь периметра: по плоскостным осям, толщина не меняется */
    line.scale.copy(__wireInsetScale(eg.boundingBox, WIRE_INSET));
    line.renderOrder = 10;
    line.frustumCulled = false;
    line.userData = { __wire: true };

    child.add(line);
    if (only) {
      child.updateMatrixWorld(true);
      model.attach(line);                   /* линия живёт отдельно от детали */
    }
    __wireItems.push({ line: line, mesh: only ? child : null });
    victims.push(child);
  });

  if (only) {
    /* Скрываем ВСЕ меши с текстурами: пласть, кромку, плёнку. Раньше плёнка и
       полосы кромки отфильтровывались от построения линий — и оставались
       видимыми полупрозрачными пятнами в режиме «только сетка». */
    model.traverse(o => {
      if (!o.isMesh) return;
      if (!o.visible) return;
      o.visible = false;
      __wireItems.push({ line: null, mesh: o });
    });
  }
  console.log('[viewer] сетка:', only ? 'только линии' : 'поверх модели',
              '| деталей:', victims.length, '| сдвиг', WIRE_INSET, 'мм');
}

/* Переключение режимов сетки. Каждая кнопка включает СВОЙ режим:
   «Сетка» — линии поверх текстур, «Сетчатый» — только линии без текстур.
   Нажатие на активную кнопку выключает режим; нажатие на другую — переключает. */
function __setWireMode(mode) {
  if (!model) return;

  if (__wireMode === mode) { __clearWireframe(); isWireframe = false; return; }

  if (__wireMode) { __clearWireframe(); }

  if (mode === 'only' && __alpha.on && typeof toggleAlpha === 'function') {
    try { toggleAlpha(); } catch (eAl) {}    /* прозрачность тут не нужна */
  }

  __wireMode = mode;
  isWireframe = true;
  __buildWireframe({ only: mode === 'only' });
  __syncWireMenu();
}

function toggleWireframe() { __setWireMode('overlay'); }   /* «Сетка» */
function toggleEdges() { __setWireMode('only'); }          /* «Сетчатый» */

function toggleLight2() {
  if (!model) return;
  isLight = !isLight;
  if (isLight) {    
    model.traverse(child => {
      if (child.isMesh && child.material.name == "x5") {
        //console.log('child:', child);
        child.material = new THREE.MeshStandardMaterial({
          color: 0xffaa33,
          emissive: 0xffaa33,
          emissiveIntensity: 10, // Яркое свечение
          roughness: 0.5, // Глянцевый
          metalness: 0.2 // Не металлический
          // ВСЁ! Никакой прозрачности
        });
        child.material.needsUpdate = true;
       }
    });
        // Добавляем теплый точечный свет
        //const glowLight = new THREE.PointLight(0xffaa33, 0.3, 2);
        const ambientLight = new THREE.AmbientLight(0xffaa33, 0.6);
        scene.add(ambientLight);
        /*const helper = new THREE.PointLightHelper(ambientLight, 0.5);
        scene.add(helper);  */
    document.getElementById('mnu_light').classList.add('selected');
  }
}

function toggleLight() {
  if (!model) return;

  isLight = !isLight;

  model.traverse(child => {

      if (!child.isMesh) return;
      if (child.material?.name !== "x5") return;

      // ==========================================
      // ON
      // ==========================================

      if (isLight) {

          // Сохраняем оригинальный материал
          child.userData.originalMaterial = child.material;


          // LED материал
          const ledMaterial = new THREE.MeshStandardMaterial({
              color: 0xffa040,
              emissive: 0xff7518,
              emissiveIntensity: 8,

              roughness: 0.25,
              metalness: 0,

              toneMapped: false
          });

          ledMaterial.name = "x5";

          child.material = ledMaterial;


          // ==========================================
          // ЦЕНТР ГЕОМЕТРИИ
          // ==========================================

          child.geometry.computeBoundingBox();

          const center = new THREE.Vector3();

          child.geometry.boundingBox.getCenter(center);
          
          console.log("MESH:", child);
          console.log("LED MESH:", child.name);
          console.log("LOCAL CENTER:", center);


          // ==========================================
          // POINT LIGHT
          // ==========================================

          const ledLight = new THREE.PointLight(
              0xff9638,
              5,
              0,3,
              2
          );

          // !!! ВАЖНО !!!
          // center находится в локальных координатах child
          // поэтому light тоже добавляем в child

          ledLight.position.copy(center);

          child.add(ledLight);

          child.userData.ledLight = ledLight;


          // Helper для проверки
          const helper = new THREE.PointLightHelper(
              ledLight,
              0.4
          );

          child.add(helper);

          child.userData.ledHelper = helper;
      }


      // ==========================================
      // OFF
      // ==========================================

      else {

          if (child.userData.ledHelper) {
              child.remove(child.userData.ledHelper);
              child.userData.ledHelper = null;
          }

          if (child.userData.ledLight) {
              child.remove(child.userData.ledLight);
              child.userData.ledLight = null;
          }

          if (child.userData.originalMaterial) {
              child.material = child.userData.originalMaterial;
              child.userData.originalMaterial = null;
          }
      }
  });
}

// Плоские материалы без сложного света
let __flatWhiteMat = null;
let __flatApplied = false;      /* фактическое состояние: применён ли белый */

function toggleFlatMaterial() {
  if (!model) return;
  /* Состояние берём по факту применения, а не по флагу: если разметка меню
     пришла с «selected», первый клик раньше только «восстанавливал»
     материалы — и визуально ничего не менялось. */
  isFlat = !__flatApplied;
  if (isFlat) {
    /* Режим «Без текстур»: показываем модель сплошным БЕЛЫМ материалом — ни карт,
       ни тонирования по текстуре. Нужен, чтобы глазами проверять геометрию:
       кромки, пазы, вырезы. Раньше брался 0xfafafa (не белый) и Lambert, из-за
       чего детали выглядели серыми. */
    const whiteMat = new THREE.MeshStandardMaterial({
      color: 0xffffff,
      roughness: 0.9,
      metalness: 0.0,
      emissive: 0xffffff,
      emissiveIntensity: 0.12,     /* подъём теней: белое читается белым */
      /* flatShading считает нормаль в шейдере из производных — белый режим
         работает даже там, где у геометрии нет атрибута normal (меши Базиса).
         DoubleSide — чтобы не было чёрных граней от обратных сторон. */
      flatShading: true,
      side: THREE.DoubleSide
    });
    if (!__flatWhiteMat) { __flatWhiteMat = whiteMat; }

    let whiteCount = 0, noNormals = 0;
    model.traverse(child => {
      if (!child.isMesh) return;
      const g = child.geometry;
      if (g && !g.attributes.normal) noNormals++;
      child.material = __flatWhiteMat;
      child.material.needsUpdate = true;
      whiteCount++;
    });
    try { console.log('[viewer] мешей без нормалей:', noNormals); } catch (eNN) {}
    try { console.log('[viewer] белый материал применён к мешам:', whiteCount); } catch (eW2) {}
    /* Освещение НЕ трогаем: toggleXRayLighting() удаляет все источники и
       окружение, оставляя один направленный свет — белый материал после этого
       выглядел почти чёрным (именно это и было видно на скриншоте). */
    document.getElementById('mnu_flat').classList.add('selected');
  } else {
    // Восстанавливаем оригинальные материалы
    originalMaterials.forEach(obj => {
      obj.mesh.material = obj.material;
      obj.mesh.material.needsUpdate = true;
    });
    document.getElementById('mnu_flat').classList.remove('selected');
  }

  __flatApplied = isFlat;
  try { console.log('[viewer] режим «Без текстур»:', isFlat ? 'белый материал' : 'исходные материалы'); } catch (eLog) {}
}

// --- Данные Базиса: анимации дверей, подсветка, крепёж -------------------
const __basisClock = new THREE.Clock();
function clockDelta() { return __basisClock.getDelta(); }

let __basisState = { doorsOpen: false, lightsOn: false, hardwareShown: true, lights: [], hardware: [], bloomMeshes: [], areaLights: [] };
try { window.__basisState = __basisState; } catch (e) {}

function __hideOutlines() {
  if (!model) return;
  let n = 0;
  model.traverse(o => {
    if (o.userData && o.userData.outline) { o.visible = false; n++; }
  });
  if (n) console.log('[viewer] контуров деталей скрыто до включения сетки:', n);
}

/* ======================= СЕЛЕКТИВНЫЙ BLOOM =============================== */
function setupBloom() {
  if (__bloom) return;
  if (typeof THREE.EffectComposer === 'undefined' ||
      typeof THREE.UnrealBloomPass === 'undefined' ||
      typeof THREE.ShaderPass === 'undefined' ||
      typeof THREE.OutputPass === 'undefined') {
    console.warn('[bloom] postprocessing-аддоны не загрузились — свечение будет без ореола');
    return;
  }
  try {
    if (THREE.RectAreaLightUniformsLib) THREE.RectAreaLightUniformsLib.init();

    const size = renderer.getSize(new THREE.Vector2());
    const bloomPass = new THREE.UnrealBloomPass(
      new THREE.Vector2(size.width, size.height),
      BLOOM_STRENGTH, BLOOM_RADIUS, BLOOM_THRESHOLD
    );

    const bloomComposer = new THREE.EffectComposer(renderer);
    bloomComposer.renderToScreen = false;
    bloomComposer.addPass(new THREE.RenderPass(scene, camera));
    bloomComposer.addPass(bloomPass);

    /* Финальный проход: обычная сцена + аддитивно bloom-текстура.
       Tone mapping и перевод в sRGB делает OutputPass ниже — в render target
       three отдаёт линейный HDR, и без него яркие пиксели уходят в белый. */
    const mixPass = new THREE.ShaderPass(new THREE.ShaderMaterial({
      uniforms: {
        baseTexture: { value: null },
        bloomTexture: { value: bloomComposer.renderTarget2.texture }
      },
      vertexShader: `
        varying vec2 vUv;
        void main(){ vUv = uv; gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0); }
      `,
      fragmentShader: `
        uniform sampler2D baseTexture;
        uniform sampler2D bloomTexture;
        varying vec2 vUv;
        void main(){
          vec4 base = texture2D(baseTexture, vUv);
          vec4 bloom = texture2D(bloomTexture, vUv);
          gl_FragColor = vec4(base.rgb + bloom.rgb, base.a);
        }
      `
    }), 'baseTexture');
    mixPass.needsSwap = true;

    const finalComposer = new THREE.EffectComposer(renderer);
    finalComposer.addPass(new THREE.RenderPass(scene, camera));
    finalComposer.addPass(mixPass);
    /* В r180 RenderPass в render target отдаёт ЛИНЕЙНЫЙ HDR без tone mapping.
       Без OutputPass финальный шейдер кладёт >1 прямо на экран — белые полки
       и «лампа на 250 Вт». OutputPass делает ACES + sRGB, как обычный рендер. */
    finalComposer.addPass(new THREE.OutputPass());

    __bloom = {
      bloomComposer: bloomComposer,
      finalComposer: finalComposer,
      bloomPass: bloomPass,
      mixPass: mixPass,
      layer: new THREE.Layers(),
      hidden: new Map(),
      hiddenVisible: new Map(),
      /* depthWrite/depthTest ВКЛЮЧЕНЫ: иначе bloom-проход рисует LED-ленты
         внутри шкафа сквозь закрытые дверцы — кажется, что модель стала
         прозрачной и «видна сетка внутри». Чёрный материал должен писать
         глубину, чтобы перекрывать светящиеся детали за собой. */
      darkMaterial: new THREE.MeshBasicMaterial({ color: 0x000000, depthWrite: true, depthTest: true })
    };
    __bloom.layer.set(BLOOM_LAYER);
    camera.layers.enable(BLOOM_LAYER);
    try { window.__bloom = __bloom; } catch (eDbg) {}
    __resizeBloom(size.width, size.height);
    console.log('[bloom] селективный bloom готов');
  } catch (e) {
    console.warn('[bloom] не удалось создать композер:', e && e.message ? e.message : e);
    __bloom = null;
  }
}

function __resizeBloom(w, h) {
  if (!__bloom) return;
  try {
    __bloom.bloomComposer.setSize(w, h);
    __bloom.finalComposer.setSize(w, h);
    if (__bloom.bloomPass.resolution && __bloom.bloomPass.resolution.set) {
      __bloom.bloomPass.resolution.set(w, h);
    }
  } catch (e) {}
}

function __bloomDarken(obj) {
  if (!__bloom) return;
  if (__bloom.layer.test(obj.layers)) return;
  if (obj.isMesh) {
    if (!obj.material) return;
    __bloom.hidden.set(obj.uuid, obj.material);
    obj.material = __bloom.darkMaterial;
    return;
  }
  /* Сетка, контуры, размеры и спрайты — не меши. В bloom-буфере они
     оставались яркими и подсвечивались поверх модели («сетка внутри»,
     «наружная сетка светлее»). На время bloom-прохода просто прячем. */
  if (obj.isLine || obj.isPoints || obj.isSprite) {
    __bloom.hiddenVisible.set(obj.uuid, obj.visible);
    obj.visible = false;
  }
}

function __bloomRestore(obj) {
  if (!__bloom) return;
  if (__bloom.hiddenVisible.has(obj.uuid)) {
    obj.visible = __bloom.hiddenVisible.get(obj.uuid);
    __bloom.hiddenVisible.delete(obj.uuid);
  }
  if (!obj.isMesh) return;
  const mat = __bloom.hidden.get(obj.uuid);
  if (mat) {
    obj.material = mat;
    __bloom.hidden.delete(obj.uuid);
  }
}

function renderScene() {
  /* Без включённой подсветки или без светящихся мешей рендерим напрямую:
     композер без MSAA делает картинку чуть мягче, это заметно на модели. */
  if (!__bloom || !__basisState.lightsOn ||
      !__basisState.bloomMeshes || !__basisState.bloomMeshes.length) {
    renderer.render(scene, camera);
    return;
  }

  const savedBackground = scene.background;
  const savedClear = renderer.getClearColor(new THREE.Color());
  const savedClearAlpha = renderer.getClearAlpha();
  scene.background = null;
  renderer.setClearColor(0x000000, 0);
  scene.traverse(__bloomDarken);
  try {
    __bloom.bloomComposer.render();
    /* UnrealBloomPass (r180) кладёт готовый результат в readBuffer, а не в
       renderTarget2 — без этой строки в финал уходит пустая текстура. */
    if (__bloom.mixPass && __bloom.mixPass.material && __bloom.mixPass.material.uniforms) {
      __bloom.mixPass.material.uniforms.bloomTexture.value =
        __bloom.bloomComposer.readBuffer.texture;
    }
  } finally {
    scene.traverse(__bloomRestore);
    scene.background = savedBackground;
    renderer.setClearColor(savedClear, savedClearAlpha);
  }
  __bloom.finalComposer.render();
}

/* Fotly ставит на светящуюся панель не точечный источник, а RectAreaLight
   ровно по её площади. Для длинной ленты это даёт мягкий свет без
   «выжигания» стены в точке (1/r² у PointLight на поверхности бесконечен).
   Берём геометрию LED/линзы, две наибольшие стороны — площадь, меньшая —
   нормаль. Светим ОДНУ сторону: находим ближайшую панель (полку/стенку) и
   направляем свет от неё, иначе лента под полкой светила бы и на верх полки. */
function __createAreaLights(meshes) {
  if (typeof THREE.RectAreaLight === 'undefined') return [];
  const panelMeshes = [];
  let modelCenter = new THREE.Vector3();
  try {
    if (model) {
      model.traverse(o => {
        if (!o.isMesh || !o.visible) return;
        const k = o.userData && (o.userData.kind || o.userData.role);
        if (k === 'panel' || k === 'contour' || k === 'carcass') panelMeshes.push(o);
      });
      modelCenter = new THREE.Box3().setFromObject(model).getCenter(new THREE.Vector3());
    }
  } catch (ePanels) {}
  const raycaster = new THREE.Raycaster();
  raycaster.near = 0;
  raycaster.far = 0.15;

  const candidates = [];
  for (const mesh of meshes || []) {
    if (!mesh.geometry) continue;
    try { mesh.geometry.computeBoundingBox(); } catch (e) { continue; }
    const box = mesh.geometry.boundingBox;
    if (!box) continue;
    const size = box.getSize(new THREE.Vector3());
    const dims = [size.x, size.y, size.z];
    const order = [0, 1, 2].sort((a, b) => dims[b] - dims[a]);
    const maxDim = dims[order[0]];
    if (!(maxDim > 0.12)) continue;          // мелкие коннекторы не светим площадью
    candidates.push({ mesh, box, size, dims, order, maxDim });
  }
  candidates.sort((a, b) => b.maxDim - a.maxDim);

  const out = [];
  const isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent || '');
  const MAX_AREA_LIGHTS = isMobile ? 3 : 6;
  for (const c of candidates) {
    if (out.length >= MAX_AREA_LIGHTS) break;
    const mesh = c.mesh;
    const iw = c.order[0], ih = c.order[1], inorm = c.order[2];
    const width = c.dims[iw], height = c.dims[ih];
    if (!(width > 0.005) || !(height > 0.001)) continue;
    if (!(c.dims[inorm] < Math.min(width, height))) continue;  // должна быть плоской

    const axes = [
      new THREE.Vector3(1, 0, 0),
      new THREE.Vector3(0, 1, 0),
      new THREE.Vector3(0, 0, 1)
    ];
    const widthDir = axes[iw].clone().transformDirection(mesh.matrixWorld).normalize();
    const heightDir = axes[ih].clone().transformDirection(mesh.matrixWorld).normalize();
    const normalDir = new THREE.Vector3().crossVectors(widthDir, heightDir).normalize();
    const center = c.box.getCenter(new THREE.Vector3()).applyMatrix4(mesh.matrixWorld);

    let color = new THREE.Color('#ffe6bd');
    const mats = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
    for (const m of mats) {
      if (m && m.emissive && (m.emissive.r + m.emissive.g + m.emissive.b) > 0.01) {
        color = m.emissive.clone();
        break;
      }
    }

    /* Куда светить: от ближайшей панели. Лента под полкой упирается в полку
       сверху — значит светим вниз; вертикальная лента на стенке — от стенки. */
    let emitSign = 1;
    let panelPos = false, panelNeg = false;
    if (panelMeshes.length) {
      const eps = 0.001;
      raycaster.set(center.clone().addScaledVector(normalDir, eps), normalDir);
      panelPos = raycaster.intersectObjects(panelMeshes, false).length > 0;
      raycaster.set(center.clone().addScaledVector(normalDir, -eps), normalDir.clone().negate());
      panelNeg = raycaster.intersectObjects(panelMeshes, false).length > 0;
    }
    if (panelPos && !panelNeg) emitSign = -1;
    else if (panelNeg && !panelPos) emitSign = 1;
    else if (Math.abs(normalDir.y) > 0.7) {
      /* горизонтальная лента без панели: под полкой светит вниз */
      emitSign = normalDir.y > 0 ? -1 : 1;
    } else {
      /* вертикальная: внутрь модели, а не наружу */
      const toCenter = modelCenter.clone().sub(center);
      emitSign = normalDir.dot(toCenter) >= 0 ? 1 : -1;
    }

    const light = new THREE.RectAreaLight(color, 0, width, height);
    light.matrixAutoUpdate = false;
    light.matrix.makeBasis(widthDir, heightDir, normalDir.clone().multiplyScalar(-emitSign));
    light.matrix.setPosition(center);
    light.matrixWorldNeedsUpdate = true;
    light.userData.__baseIntensity = 0.08;
    light.visible = true;
    light.intensity = 0;
    scene.add(light);
    out.push(light);
  }
  return out;
}

function initBasisExtras(gltf) {
  /* Площадные источники добавляются в scene, а не в model — при загрузке
     следующей модели их нужно снять, иначе они останутся висеть в сцене. */
  if (__basisState.areaLights && __basisState.areaLights.length) {
    __basisState.areaLights.forEach(l => { if (l.parent) l.parent.remove(l); });
    __basisState.areaLights = [];
  }
  try {
    const facades = [], hardware = [], lights = [];

    /* Фурнитура — это не только меши: крепёж рисуется линиями и точками,
       а сборки приходят группами. Поэтому собираем САМЫЕ ВЕРХНИЕ объекты,
       помеченные как фурнитура, и прячем их целиком. */
    const isHwObj = (o) => o && o.userData && (
      o.userData.hw === true ||
      o.userData.role === 'hole' ||
      o.userData.role === 'hardware' ||
      !!o.userData.type ||            // старые модели без флага hw
      !!o.userData.asm                // детали сборки TFurnAsm / TAsmKit
    );

    model.traverse(o => {
      const ud = o.userData || {};
      if (ud.role === 'facade' || ud.role === 'drawer-front') { facades.push(o); }
      if (!isHwObj(o)) return;
      let top = o;
      let cur = o.parent;
      while (cur && cur !== model) {
        if (isHwObj(cur)) { top = cur; }
        cur = cur.parent;
      }
      if (hardware.indexOf(top) < 0) { hardware.push(top); }
    });
    scene.traverse(o => { if (o.isPointLight) lights.push(o); });

    __basisState.hardware = hardware;
    __basisState.lights = lights;

    /* Диагностика симметричной фурнитуры: выгрузчик 1.4.2 пишет отражённые
       кадры честно (det < 0), вьювер three такие узлы рисует правильно.
       Счётчик нужен, чтобы при проверке модели было видно, что зеркала
       доехали: [mirror] узлов с отражением: N. */
    try {
      model.updateMatrixWorld(true);
      let mirrored = 0;
      model.traverse((o) => {
        if (!o.isMesh || !o.matrixWorld) { return; }
        if (o.matrixWorld.determinant() < 0) { mirrored++; }
      });
      window.__mirrorCount = mirrored;
      if (mirrored) { console.log('[mirror] узлов с отражением:', mirrored); }
    } catch (eMir) { /* не критично */ }

    /* Пункт меню «Свет» — только для моделей, где источники света есть */
    const lightItem = document.getElementById('mnu_light');
    if (lightItem) {
      if (lights.length) {
        lightItem.classList.remove('hidden-field');
        console.log('[light] источников света:', lights.length);
      } else {
        lightItem.classList.add('hidden-field');
      }
    }
    /* Свет: радиус 1 м, но панели отбрасывают тени — иначе лента светит
       сквозь боковину. Тени считаем один раз (сцена статична) и держим
       shadowMap.autoUpdate = false, чтобы не платить за них каждый кадр. */
    if (lights.length) {
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.PCFShadowMap;   // PCFSoft игнорирует shadow.radius
      renderer.shadowMap.autoUpdate = false;
      model.traverse(o => {
        if (o.isMesh) { o.castShadow = true; o.receiveShadow = true; }
      });
    }
    /* Свет ленты. Точечные источники оставляем (они дают свет во все стороны —
       так и должна работать лента в профиле), но:
         * отодвигаем каждый на 5 см от стенки — иначе 1/r² выбивает её в белое;
         * интенсивность берём из GLB (там канделы) с небольшим усилением:
           раньше стояло ×40, это и давало пересвет;
         * тени смягчаем через shadow.radius, считаем один раз. */
    try {
      /* Крутилки: offset — на сколько отодвинуть от стенки (м),
         gain — усиление кандел из GLB, distance/decay — спад.
         Если свет всё ещё бьёт в стенку: поднять offset и снизить gain. */
      /* Семь источников на 1.6 м суммируются на стенке — поэтому gain низкий.
         Общую мягкую подсветку даёт заливка (см. ниже), а источники — только
         локальный градиент у ленты. */
      /* Обрезку (distance) нельзя убирать совсем: за пределами карты теней
         (shadow.camera.far) свет перестаёт затеняться и проходит сквозь шкаф.
         Поэтому радиус есть, но он БОЛЬШЕ ширины крыши (1.31 м): сфера обрезки
         пересекает плоскость уже за деталью, и резкого круга не видно.
         Дальнюю боковину (1.35 м) держит тень, а не обрезка. */
      /* offset = 0 — источник стоит ровно на ленте, как в Fotly.
         Яркость подобрана так, чтобы 1/r² не выжигал стенку вплотную. */
      const lightParams = { offset: 0.0, gain: 0.004, distance: 1.25, decay: 2.0 };

      /* Каждая тень занимает текстурный слот в шейдере, а лимит — 16 на всё
         (свои карты материала + окружение). Когда источников много (профиль
         скопировали несколько раз), шейдер перестаёт компилироваться и пропадает
         вся сцена. Поэтому тени получают только несколько источников. */
      const MAX_SHADOW_LIGHTS = 4;
      const shadowStep = Math.max(1, Math.ceil(lights.length / MAX_SHADOW_LIGHTS));
      let shadowCount = 0;
      console.log('[led] всего источников:', lights.length, '| с тенями:',
                  Math.min(lights.length, MAX_SHADOW_LIGHTS));

      __basisState.lights = [];
      lights.forEach((src, idx) => {
        const base = (src.userData.__baseIntensity || src.intensity || 1);
        src.userData.__baseIntensity = base * lightParams.gain;
        src.intensity = 0;                     // включается кнопкой
        src.distance = lightParams.distance;
        src.decay = lightParams.decay;
        /* равномерно распределяем тени по ленте, чтобы не только один край */
        const wantShadow = (idx % shadowStep === 0) && shadowCount < MAX_SHADOW_LIGHTS;
        if (wantShadow) { shadowCount++; }
        src.castShadow = wantShadow;
        src.shadow.mapSize.set(256, 256);
        src.shadow.bias = -0.002;
        src.shadow.radius = 6;    // мягкая кромка затенения
        src.shadow.camera.near = 0.02;
        src.shadow.camera.far = 1.6;   // перекрывает радиус света, иначе свет уходит из теней
        src.shadow.autoUpdate = false;
        src.shadow.needsUpdate = false;   // запечём при включении подсветки

        __basisState.lights.push(src);
      });

      /* Мягкая заливка тёплым цветом: без неё свет от точек даёт жёсткий
         контраст у стенок и «лужи» на полках. Теней не даёт — только смягчает. */
      const fill = new THREE.HemisphereLight(0xfff0d8, 0x2a2a2a, 0);
      fill.position.set(0, 1, 0);
      model.add(fill);
      __basisState.ledFill = fill;

      console.log('[led] источников:', __basisState.lights.length,
                  '| усиление ×', lightParams.gain, '| радиус', lightParams.distance, 'м');
    } catch (eLight) {
      console.error('[basis] свет не настроен, оставляю как есть:', eLight);
      __basisState.lights = lights;
      lights.forEach(l => { l.intensity = 0; });
    }

    /* Линза светится вместе с лентой: материалы ищем по имени, а также
       по роли детали (role=led), которую ставит выгрузчик Базиса. */
    __basisState.lensMats = [];
    __basisState.bloomMeshes = [];
    model.traverse(o => {
      if (!o.isMesh) return;
      const ud = o.userData || {};
      const isLedPart = ud.role === 'led' || ud.kind === 'led';
      const mats = Array.isArray(o.material) ? o.material : [o.material];
      mats.forEach(m => {
        const nm = m && m.name ? String(m.name) : '';
        /* Внимание: у алюминиевого профиля в имени есть «светодиодной» —
           его из светящихся исключаем, иначе светится сам короб. */
        const isProfile = /профил|алюмин/i.test(nm);
        const isLens = !isProfile && /линз|рассеив|lens|диффуз|молочн/i.test(nm);
        const isTape = isLedPart || (!isProfile && /led|светодиод|лент/i.test(nm));
        if (isLens || isTape) {
          m.emissive = new THREE.Color(isLens ? '#ffe0a0' : '#fff0c8');
          m.emissiveIntensity = LED_EMISSIVE_OFF;
          m.userData.__ledKind = isLens ? 'lens' : 'tape';
          m.toneMapped = false;          // светящаяся полоса не должна темнеть от ACES
          if (isLens) {
            /* depthTest = false рисовал линзу поверх всего — она «вылезала»
               наружу шкафа. Поэтому обычная глубина, но линза становится
               плотной: transmission убираем, иначе она читается как плёнка
               и свечение на ней не видно. */
            m.depthTest = true;
            m.depthWrite = true;
            m.transparent = false;
            m.opacity = 1;
            m.transmission = 0;
          } else {
            /* У ленты в GLB бывает transparent:true/opacity:0.85. В обычном
               рендере это почти не видно, а с bloom-композером сквозь неё
               начинает просвечивать фон — деталь кажется полупрозрачной.
               Для светящейся ленты прозрачность не нужна. */
            m.depthTest = true;
            m.depthWrite = true;
            m.transparent = false;
            m.opacity = 1;
          }
          m.needsUpdate = true;
          if (__basisState.lensMats.indexOf(m) < 0) __basisState.lensMats.push(m);
          o.layers.enable(BLOOM_LAYER);
          if (__basisState.bloomMeshes.indexOf(o) < 0) __basisState.bloomMeshes.push(o);
          console.log('[led] светящийся материал:', isLens ? 'линза' : 'лента', '—', nm);
        }
      });
    });

    /* Длинные LED-ленты/линзы освещаем площадью (RectAreaLight), а не
       точечными источниками на поверхности: так нет пересвета у стенки.
       Точечные оставляем только как аварийный путь, если площадь не нашли. */
    try {
      model.updateMatrixWorld(true);
      const areaLights = __createAreaLights(__basisState.bloomMeshes);
      if (areaLights.length) {
        lights.forEach(l => { l.intensity = 0; l.visible = false; });
        __basisState.areaLights = areaLights;
        __basisState.lights = areaLights;
        console.log('[led] площадных источников:', areaLights.length,
                    '(точечные скрыты)');
      }
    } catch (eArea) {
      console.warn('[led] площадные источники не создались:', eArea && eArea.message ? eArea.message : eArea);
    }

    let actions = [];
    let doorActions = [];
    let drawerActions = [];
    if (gltf.animations && gltf.animations.length) {
      window.__basisMixer = new THREE.AnimationMixer(model);
      actions = gltf.animations.map(clip => {
        const a = window.__basisMixer.clipAction(clip);
        a.clampWhenFinished = true;
        a.loop = THREE.LoopOnce;
        return a;
      });
      /* имена клипов приходят с префиксом: door_* открываются, drawer_* едут */
      doorActions = actions.filter(a => !String(a.getClip().name).startsWith('drawer_'));
      drawerActions = actions.filter(a => String(a.getClip().name).startsWith('drawer_'));
    }

    const faceMenu = document.getElementById('face_menu');
    if (!faceMenu) return;

    function addButton(id, text, title, onClick) {
      /* Пункт может уже быть в правом меню (разметка model.hbs): тогда просто
         навешиваем обработчик и показываем его — новых кнопок не создаём. */
      const existing = document.getElementById(id);
      if (existing) {
        existing.addEventListener('click', onClick);
        existing.classList.remove('hidden-field');
        if (existing.classList.contains('menu-item')) {
          existing.classList.toggle('selected', false);
        }
        return;
      }
      const b = document.createElement('button');
      b.id = id;
      b.className = 'menu-faces';
      b.dataset.tooltip = title;
      b.title = title;
      /* PNG-иконка, если передали путь к картинке, иначе — эмодзи/текст.
         Отступы/центровку иконке задаёт класс menu-icon-btn (см. CSS), а не
         inline-стиль: так правило действует на все кнопки с иконкой, а не
         только на ту, что создаётся здесь. */
      if (typeof __setMenuIcon === 'function' && __isIconPath(text)) {
        __setMenuIcon(b, text, title);
      } else {
        b.textContent = text;
        b.style.fontSize = '20px';
        b.style.lineHeight = '1';
      }
      b.addEventListener('click', onClick);
      faceMenu.appendChild(b);
    }

    console.log('[basis] клипы:', (gltf.animations || []).map(a => a.name).join(', ') || 'нет');

    console.log('[basis] данные: фурнитура =', hardware.length, '| свет =', lights.length,
                '| клипы =', actions.length);

    let __animChecked = false;

    function playGroup(list, open) {
      /* Один раз проверяем, что узлы, к которым привязаны дорожки, реально
         есть в модели: иначе анимация «играет» в пустоту и ничего не видно. */
      if (!__animChecked) {
        __animChecked = true;
        list.forEach(a => {
          const clip = a.getClip();
          clip.tracks.forEach(tr => {
            const nodeName = String(tr.name).split('.')[0];
            const found = model.getObjectByName(nodeName);
            console.log('[anim]', clip.name, '| дорожка:', tr.name,
                        '| узел найден:', !!found,
                        found ? '' : '← ТАКОГО УЗЛА В МОДЕЛИ НЕТ');
          });
        });
      }

      list.forEach(a => {
        const dur = a.getClip().duration;
        a.paused = false;
        if (open) { a.reset(); a.timeScale = 1; }
        else { a.time = dur; a.timeScale = -1; }
        a.play();
      });
    }

    /* кнопки анимаций показываем только если в модели есть чем их проигрывать */
    /* левая панель нужна, только если в ней есть что показывать */
    const facesLeftBtn = document.getElementById('mnu_faces');
    if (facesLeftBtn && __facadesFound()) { facesLeftBtn.classList.remove('hidden-field'); }
    else if (facesLeftBtn) { facesLeftBtn.classList.add('hidden-field'); }

    const doorsBtnEl = document.getElementById('mnu_doors');
    if (!doorActions.length && doorsBtnEl) { doorsBtnEl.classList.add('hidden-field'); }
    if (doorActions.length) {
    addButton('mnu_doors', '🚪', 'Открыть двери', () => {
      if (!doorActions.length) { console.warn('[doors] в модели нет клипов дверей'); return; }
      __basisState.doorsOpen = !__basisState.doorsOpen;
      console.log('[doors] двери:', __basisState.doorsOpen, '| клипов:', doorActions.length);
      playGroup(doorActions, __basisState.doorsOpen);
    });
    }

    const drawersBtnEl = document.getElementById('mnu_drawers');
    if (!drawerActions.length && drawersBtnEl) { drawersBtnEl.classList.add('hidden-field'); }
    if (doorActions.length || drawerActions.length || __facadesFound()) {
      const fm = document.getElementById('face_menu');
      if (fm) { fm.classList.remove('hidden-field'); }
    }

    if (drawerActions.length) {
      addButton('mnu_drawers', '🗄️', 'Выдвинуть ящики', () => {
        __basisState.drawersOpen = !__basisState.drawersOpen;
        console.log('[doors] ящики:', __basisState.drawersOpen, '| клипов:', drawerActions.length);
        playGroup(drawerActions, __basisState.drawersOpen);
      });
    }

    /* ------------------------- РАЗБОР (exploded view) -----------------------
       Детали разъезжаются от центра модели, на каждой появляется номер.
       Реализация через обёртку и Object3D.attach(): она сохраняет мировое
       положение детали независимо от того, как та задана (position, матрица,
       внутри анимированного узла). */
    const explUnits = [];
    const explTags = [];
    let explOn = false;
    let explAmp = 0;
    let explAmpWorld = 0;
    const explCenter = new THREE.Vector3();

    const explBar = document.createElement('div');
    explBar.id = 'explode_bar';
    /* Стиль как у выпадающего меню: серый полупрозрачный фон с блюром */
    explBar.style.cssText = 'position:fixed;left:50%;bottom:18px;transform:translateX(-50%);' +
      'z-index:30;display:none;align-items:center;gap:12px;padding:8px 14px;border-radius:6px;' +
      'background-color:rgba(30,30,30,.55);backdrop-filter:blur(10px);' +
      'color:#fff;font:14px/1.2 Ubuntu,system-ui,sans-serif;' +
      'box-shadow:0 5px 20px rgba(0,0,0,.3)';
    explBar.innerHTML = '<span style="opacity:.75">Взрыв</span>' +
      '<input id="explode_slider" type="range" min="0" max="100" value="0" ' +
      'style="width:190px;accent-color:#E3BD33">' +
      '<span id="explode_val" style="width:36px;text-align:right;color:#fff;' +
      'font-variant-numeric:tabular-nums">0</span>';
    document.body.appendChild(explBar);

    function explCollect() {
      if (explUnits.length) return;
      model.updateMatrixWorld(true);

      const box = new THREE.Box3().setFromObject(model);
      box.getCenter(explCenter);
      const wSize = box.getSize(new THREE.Vector3());
      const worldSize = wSize.length() || 1;
      explAmpWorld = worldSize * 0.5;
      explAmp = explAmpWorld / (model.scale.x || 1);

      /* Стиль разбора. 'radial' — как было (направление строго от центра
         модели к центру детали, одинаковое расстояние для всех).
         'hybrid' — предложение: к радиальному направлению подмешивается 30 %
         осевой составляющей, а дальние детали уезжают чуть сильнее, ближние —
         слабее. Переключить можно в консоли, без правки кода:

             window.__explodeStyle = 'radial';   // вернуть как было
             window.__explodeStyle = 'hybrid';   // предложенный вариант

         После смены нужно выключить и включить «Разбор» (стиль читается при
         сборе единиц). */
      const explStyle = (typeof window !== 'undefined' && window.__explodeStyle) || 'hybrid';
      const half = new THREE.Vector3(
        Math.max(1e-6, wSize.x / 2), Math.max(1e-6, wSize.y / 2), Math.max(1e-6, wSize.z / 2)
      );

      /* Деталь собираем ПО partId, а не по объекту.
         Панель с материалом кромки на торцах уезжает в glTF несколькими
         примитивами: glTFLoader делает для них группу, а extras.partId
         оказывается на КАЖДОМ дочернем меше. Из-за этого каждая грань панели
         считалась отдельной деталью и при разборе разлеталась сама по себе.
         Теперь все объекты одного partId — одна единица разбора. */
      const byPart = new Map();
      model.traverse(o => {
        const ud = o.userData;
        if (!ud || !ud.partId) return;
        /* берём только верхние объекты своего partId */
        let cur = o.parent, nested = false;
        while (cur && cur !== model) {
          if (cur.userData && cur.userData.partId === ud.partId) { nested = true; break; }
          cur = cur.parent;
        }
        if (nested) return;
        if (!byPart.has(ud.partId)) byPart.set(ud.partId, []);
        byPart.get(ud.partId).push(o);
      });

      /* сборка (TFurnAsm/TAsmKit) едет целиком: один сдвиг, один номер */
      const groups = new Map();
      byPart.forEach((objs, partId) => {
        let asm = null;
        for (const o of objs) {
          if (o.userData && o.userData.asm) { asm = o.userData.asm; break; }
        }
        const key = asm ? ('asm:' + asm) : ('one:' + partId);
        if (!groups.has(key)) groups.set(key, []);
        for (const o of objs) groups.get(key).push(o);
      });

      groups.forEach((list, gKey) => {
        const b = new THREE.Box3();
        list.forEach(part => b.expandByObject(part));
        if (b.isEmpty()) return;
        const c = b.getCenter(new THREE.Vector3());
        /* Направление. 'radial' — как было: от центра модели к центру детали.
           Привязку строго к осям не используем — она сбивала детали в группы. */
        const rel = c.clone().sub(explCenter);
        const dir = rel.clone();
        if (dir.lengthSq() < 1e-6) { dir.set(0, 1, 0); } else { dir.normalize(); }

        if (explStyle === 'hybrid') {
          /* 30 % осевой составляющей: чуть «разложить» по осям, но без
             слипания в три слоя. Направление по доминирующей оси — мягкое
             дополнение к радиальному. */
          const nx = rel.x / half.x, ny = rel.y / half.y, nz = rel.z / half.z;
          const ax = Math.abs(nx), ay = Math.abs(ny), az = Math.abs(nz);
          const axisDir = new THREE.Vector3(0, 1, 0);
          if (ax >= ay && ax >= az) { axisDir.set(Math.sign(nx) || 1, 0, 0); }
          else if (ay >= az) { axisDir.set(0, Math.sign(ny) || 1, 0); }
          else { axisDir.set(0, 0, Math.sign(nz) || 1); }

          dir.multiplyScalar(0.7).add(axisDir.multiplyScalar(0.3));
          if (dir.lengthSq() < 1e-9) dir.copy(axisDir);
          dir.normalize();
        }

        const wrap = new THREE.Group();
        wrap.name = 'explode-' + explUnits.length;
        model.add(wrap);
        list.forEach(part => wrap.attach(part));

        const ud = (list[0] && list[0].userData) || {};
        explUnits.push({
          wrap: wrap,
          objs: list,
          parents: list.map(part => part.parent),
          dir: dir,
          center: c.clone(),
          isAsm: String(gKey).indexOf('asm:') === 0,
          /* Номер/обозначение берём всегда: у панели из нескольких примитивов
             объектов больше одного, но это по-прежнему ОДНА деталь. */
          label: (String(gKey).indexOf('asm:') === 0) ? '' :
                 (String(ud.designation || '').trim() ||
                  String(ud.position || '').trim() ||
                  String(ud.name || '').trim())
        });
      });

      /* В гибридном стиле дальние детали уезжают сильнее, ближние — слабее:
         композиция «раскрывается» равномернее. В радиальном стиле усиление
         всегда 1 — поведение в точности как было. */
      let maxDist = 0;
      if (explStyle === 'hybrid') {
        explUnits.forEach(u => {
          const d = u.center.clone().sub(explCenter).length();
          u.dist = d;
          if (d > maxDist) maxDist = d;
        });
      }
      explUnits.forEach(u => {
        if (explStyle === 'hybrid' && maxDist > 0) {
          const t = Math.min(1, (u.dist || 0) / maxDist);
          u.gain = 0.6 + 0.8 * t;          /* от 0.6 (центр) до 1.4 (край) */
        } else {
          u.gain = 1;
        }
      });

      /* Фурнитура (крепёж, отверстия) уезжает вместе с ближайшей деталью.
         Переносим её в ту же обёртку через attach — тогда сдвиг общий. */
      /* Вся фурнитура: крепёж-меши (в т.ч. инстансы — ножки, петли),
         отверстия и маркеры. Помечается флагом hw в конвертере. */
      /* Дерево узлов Базиса: по нему фурнитура привязывается к детали —
         поднимаемся от узла фурнитуры вверх до узла, который есть у детали. */
      let nodeParent = {};
      try {
        if (model.userData && model.userData.nodeParent) { nodeParent = model.userData.nodeParent; }
        else {
          model.traverse(o => {
            if (!nodeParent || !Object.keys(nodeParent).length) {
              if (o.userData && o.userData.nodeParent) { nodeParent = o.userData.nodeParent; }
            }
          });
        }
      } catch (eNp) {}

      const partById = new Map();
      for (const u of explUnits) {
        for (const ob of (u.objs || [])) {
          const pid = ob.userData && ob.userData.partId;
          if (pid) { partById.set(String(pid), u); }
        }
      }

      const partByNode = new Map();
      for (const u of explUnits) {
        for (const ob of (u.objs || [])) {
          const nd = ob.userData && ob.userData.node;
          if (nd) { partByNode.set(String(nd), u); }
        }
      }

      function ownerOfNode(nd) {
        let cur = nd ? String(nd) : null;
        let guard = 0;
        while (cur && guard++ < 40) {
          const u = partByNode.get(cur);
          if (u) { return u; }
          cur = nodeParent[cur] || null;
        }
        return null;
      }

      const hw = [];
      const isHw = (o) => o && o.userData &&
        (o.userData.hw === true || o.userData.role === 'hole' || o.userData.role === 'hardware');
      model.traverse(o => {
        if (!isHw(o)) return;
        /* берём самый верхний объект, помеченный как фурнитура (группу инстанса) */
        let top = o;
        let cur = o.parent;
        while (cur && cur !== model) {
          if (isHw(cur)) top = cur;
          cur = cur.parent;
        }
        if (hw.indexOf(top) < 0) hw.push(top);
      });
      model.updateMatrixWorld(true);
      /* Габариты считаем ДО привязки фурнитуры и только по самим деталям:
         иначе в бокс попадает уже привязанная фурнитура и привязка едет. */
      for (const u of explUnits) {
        const bb = new THREE.Box3();
        (u.objs || []).forEach(ob => bb.expandByObject(ob));
        u.box = bb;
      }

      /* Привязка «по габариту» на практике уводила крепёж к случайной мелкой
         детали (точка лежит внутри нескольких боксов). Включаем её только
         если более точные пути не дали ответа. */
      const USE_CONTAIN = false;

      let byNode = 0, byNear = 0, byContain = 0, byOwner = 0;
      for (const o of hw) {
        /* 1) точная привязка из данных: панель, где просверлено отверстие */
        let best = null;
        const own = o.userData && o.userData.owner;
        if (own) { best = partById.get(String(own)) || null; }
        if (best) { byOwner++; }

        /* 1б) затем по дереву узлов Базиса */
        if (!best) {
          best = ownerOfNode(o.userData && o.userData.node);
          if (best) { byNode++; }
        }

        /* 2) узел не даёт владельца (крепёж сидит на блоке, а не на детали):
           берём деталь, в габарит которой попадает крепёж — из нескольких
           выбираем самую маленькую, она и есть «своя». */
        if (!best && USE_CONTAIN) {
          const wp = new THREE.Vector3();
          const hb = new THREE.Box3().setFromObject(o);
          if (!hb.isEmpty()) { hb.getCenter(wp); } else { o.getWorldPosition(wp); }

          const TOL = 1.0;
          let bestVol = Infinity;
          for (const u of explUnits) {
            const bb = u.box || new THREE.Box3();
            if (bb.isEmpty()) continue;
            if (wp.x < bb.min.x - TOL || wp.x > bb.max.x + TOL) continue;
            if (wp.y < bb.min.y - TOL || wp.y > bb.max.y + TOL) continue;
            if (wp.z < bb.min.z - TOL || wp.z > bb.max.z + TOL) continue;
            const sz = bb.getSize(new THREE.Vector3());
            const vol = sz.x * sz.y * sz.z;
            if (vol < bestVol) { bestVol = vol; best = u; }
          }
          if (best) { byContain = byContain + 1; }
        }

        /* 3) последний путь — по расстоянию до ГАБАРИТА детали (0 = внутри).
           Раньше сравнивались центры боксов, и болт на грани панели
           привязывался к соседней мелкой детали, чей центр оказался ближе.
           При равенстве берём деталь крупнее — она и есть несущая. */
        if (!best) {
          const wp = new THREE.Vector3();
          const hb = new THREE.Box3().setFromObject(o);
          if (!hb.isEmpty()) { hb.getCenter(wp); } else { o.getWorldPosition(wp); }

          const distToBox = (b, q) => {
            const dx = Math.max(b.min.x - q.x, 0, q.x - b.max.x);
            const dy = Math.max(b.min.y - q.y, 0, q.y - b.max.y);
            const dz = Math.max(b.min.z - q.z, 0, q.z - b.max.z);
            return Math.sqrt(dx * dx + dy * dy + dz * dz);
          };

          let bestD = Infinity, bestVol = -1;
          for (const u of explUnits) {
            const bb = u.box || u.center;      /* box посчитан заранее по деталям */
            if (!bb || !bb.isBox3 || bb.isEmpty()) continue;
            const d = distToBox(bb, wp);
            const sz = bb.getSize(new THREE.Vector3());
            const vol = sz.x * sz.y * sz.z;
            if (d < bestD - 1e-6 || (Math.abs(d - bestD) <= 1e-6 && vol > bestVol)) {
              bestD = d; bestVol = vol; best = u;
            }
          }
          if (best) { byNear++; }
        }

        if (!best) continue;
        /* Крепёж уже привязан к детали конвертером (ребёнок её узла):
           не перевешиваем — иначе после «взрыва» он перестанет ехать
           вместе с деталью в обычных анимациях. Обёртка двигает деталь,
           а крепёж внутри неё едет следом. */
        let insidePart = false;
        for (let pp = o.parent; pp && pp !== model; pp = pp.parent) {
          if (best.objs.indexOf(pp) >= 0) { insidePart = true; break; }
        }
        if (insidePart) continue;
        best.wrap.attach(o);
        best.objs.push(o);
      }
      console.log('[разбор] фурнитура: по отверстию', byOwner, '| по узлу', byNode,
                  '| по габариту детали', byContain, '| по близости', byNear);

      explUnits.sort((a, b) => a.center.x - b.center.x || a.center.z - b.center.z);
      explUnits.forEach((u, i) => {
        if (u.isAsm || !/^\d{1,3}$/.test(String(u.label || '').trim())) {
          u.label = String(i + 1);
        }
      });

      console.log('[разбор] единиц:', explUnits.length, '| амплитуда:',
                  Math.round(explAmp), '| фурнитуры:', hw.length);
    }

    function explMakeTag(text) {
      /* доступна снаружи: её же использует поиск детали */
      const F = 64;
      /* Рисуем в 4 раза крупнее и масштабируем контекст: текстура получается
         плотнее, и на экране контур остаётся чётким, а не размазанным. */
      const SS = 4;
      const probe = document.createElement('canvas').getContext('2d');
      probe.font = '700 ' + F + 'px system-ui,sans-serif';
      const tw = Math.ceil(probe.measureText(text).width);
      const cw = Math.max(112, tw + 52);
      const cv = document.createElement('canvas');
      cv.width = cw * SS; cv.height = 112 * SS;
      const x = cv.getContext('2d');
      x.scale(SS, SS);
      x.fillStyle = 'rgba(255,255,255,.98)';
      /* Путь отступаем внутрь на половину обводки: иначе её внешняя половина
         срезается краем канваса, и рядом с нарисованным скруглением видна
         вторая кромка с меньшим радиусом. */
      const LW = 4;
      const ins = LW / 2 + 0.5;
      const boxH = 112;
      const r = 26;
      const x0 = ins, y0 = ins;
      const x1 = cw - ins, y1 = boxH - ins;
      const rr = Math.min(r, (y1 - y0) / 2 - 0.5, (x1 - x0) / 2 - 0.5);

      x.beginPath();
      x.moveTo(x0 + rr, y0);
      x.lineTo(x1 - rr, y0);
      x.quadraticCurveTo(x1, y0, x1, y0 + rr);
      x.lineTo(x1, y1 - rr);
      x.quadraticCurveTo(x1, y1, x1 - rr, y1);
      x.lineTo(x0 + rr, y1);
      x.quadraticCurveTo(x0, y1, x0, y1 - rr);
      x.lineTo(x0, y0 + rr);
      x.quadraticCurveTo(x0, y0, x0 + rr, y0);
      x.closePath();
      x.fill();
      x.strokeStyle = 'rgba(96,110,128,.45)';
      x.lineWidth = LW;
      x.stroke();
      x.font = '700 ' + F + 'px system-ui,sans-serif';
      x.fillStyle = '#141a22';
      x.textAlign = 'center'; x.textBaseline = 'middle';
      x.fillText(text, cw / 2, 58);

      const tex = new THREE.CanvasTexture(cv);
      tex.colorSpace = THREE.SRGBColorSpace;
      tex.generateMipmaps = false;
      tex.minFilter = THREE.LinearFilter;
      tex.magFilter = THREE.LinearFilter;
      tex.anisotropy = 4;
      const spr = new THREE.Sprite(new THREE.SpriteMaterial({
        map: tex, transparent: true, depthTest: false, depthWrite: false
      }));
      spr.renderOrder = 999;
      const h = explAmpWorld * 0.05;
      spr.scale.set(h * (cw / 112), h, 1);
      return spr;
    }
    try { window.__explodeMakeTag = explMakeTag; } catch (eXtag) {}

    /* Плашки должны исчезать вместе с деталью: если все объекты единицы
       скрыты (например, кнопкой «Крепёж и сборки»), подпись тоже прячем. */
    window.__explodeSyncTags = () => {
      if (!explTags.length) return;
      for (const spr of explTags) {
        const u = spr.userData.unit;
        let vis = false;
        if (u && u.objs) {
          for (const ob of u.objs) { if (ob.visible) { vis = true; break; } }
        }
        spr.visible = vis;
        if (spr.userData.line) { spr.userData.line.visible = vis; }
      }
    };

    function explClearTags() {
      explTags.forEach(t => {
        const ln = t.userData && t.userData.line;
        if (ln && ln.parent) ln.parent.remove(ln);
        if (t.parent) t.parent.remove(t);
      });
      explTags.length = 0;
    }

    function explApply(frac) {
      explCollect();

      for (const u of explUnits) {
        const off = u.dir.clone().multiplyScalar(frac * explAmp * (u.gain || 1));
        u.wrap.position.copy(off);
      }
      model.updateMatrixWorld(true);

      if (frac > 0.0001) {
        if (!explTags.length) {
          for (const u of explUnits) {
            if (!u.label) continue;
            const spr = explMakeTag(u.label);
            spr.userData.unit = u;

            const lnGeo = new THREE.BufferGeometry();
            lnGeo.setAttribute('position', new THREE.Float32BufferAttribute(new Float32Array(6), 3));
            const ln = new THREE.LineSegments(lnGeo, new THREE.LineBasicMaterial({
              color: 0x39434f, transparent: true, opacity: 0.6, depthTest: false
            }));
            ln.renderOrder = 998;
            scene.add(ln);
            spr.userData.line = ln;

            scene.add(spr);
            explTags.push(spr);
          }
        }

        for (const spr of explTags) {
          const u = spr.userData.unit;
          const b = new THREE.Box3();
          u.objs.forEach(o => b.expandByObject(o));
          if (b.isEmpty()) continue;
          const c = b.getCenter(new THREE.Vector3());

          /* Выше на 30 % и ближе по глубине вдвое */
          const tagX = c.x;
          const tagY = b.max.y + explAmpWorld * 0.117;
          const tagZ = c.z + explAmpWorld * 0.08;
          spr.position.set(tagX, tagY, tagZ);

          const ln = spr.userData.line;
          if (ln && ln.geometry && ln.geometry.attributes && ln.geometry.attributes.position) {
            const posAttr = ln.geometry.attributes.position;
            posAttr.setXYZ(0, c.x, b.max.y, c.z);
            posAttr.setXYZ(1, tagX, tagY - spr.scale.y * 0.55, tagZ);
            posAttr.needsUpdate = true;
            ln.geometry.computeBoundingSphere();
          }
        }
        if (window.__explodeSyncTags) { window.__explodeSyncTags(); }
      } else {
        explClearTags();
      }
      try {
        console.log('[dims] после разбора: on=' + (typeof __dims !== 'undefined' ? __dims.on : '?'),
                    '| подписей=' + (typeof __dims !== 'undefined' ? __dims.labels.length : '?'),
                    '| в DOM=' + (typeof __dims !== 'undefined' ? __dims.labels.filter(l => l.el && l.el.isConnected).length : '?'),
                    '| explode=' + !!window.__explodeOn);
      } catch (eDg3) {}
    }

    const explBtn = document.getElementById('mnu_explode');
    const explToggle = () => {
      /* Разбор и размеры вместе не нужны: при включении разбора размеры
         гасим, чтобы не мешали и не висели в воздухе. */
      if (!explOn && typeof __dims !== 'undefined' && __dims && __dims.on) {
        try { toggleDimensions(); } catch (eTd) {}
      }
      /* Комната с разбором не нужна: при включении «Взрыва» убираем её,
         иначе детали разлетаются по полу и стене и мешают смотреть. */
      if (!explOn && __room.on) {
        try { __clearRoom(); } catch (eRoom) {}
      }
      explOn = !explOn;
      window.__explodeOn = explOn;
      if (explOn) { window.__explodeUsed = true; }
      if (explBtn) { explBtn.classList.toggle('selected', explOn); }
      explBar.style.display = explOn ? 'flex' : 'none';
      const sl = document.getElementById('explode_slider');
      const vv = document.getElementById('explode_val');
      if (!explOn) {
        window.__explodeOn = false;
        if (sl) { sl.value = '0'; }
        if (vv) { vv.textContent = '0'; }
        explApply(0);
        return;
      }
      /* При включении «Взрыва» сразу показываем ползунок и ставим его на 50 %,
         чтобы детали разъехались без ручной прокрутки. */
      if (sl) { sl.value = '50'; }
      if (vv) { vv.textContent = '50'; }
      explCollect();
      explApply(0.5);
      console.log('[взрыв] включён, единиц:', explUnits.length);
    };

    if (explBtn) { explBtn.addEventListener('click', explToggle); }

    {
      const sl = document.getElementById('explode_slider');
      const vv = document.getElementById('explode_val');
      if (sl) {
        sl.addEventListener('input', () => {
          const v = Number(sl.value) || 0;
          if (vv) { vv.textContent = String(v); }
          explApply(v / 100);
        });
      }
    }

    /* Подсветка: одна функция на левую кнопку и на пункт меню «Свет» */
    const toggleLedLights = () => {
      if (!__basisState.lights.length) { console.warn('[led] в модели нет источников света'); return; }
      {
        __basisState.lightsOn = !__basisState.lightsOn;
        if (renderer.shadowMap) renderer.shadowMap.needsUpdate = true;
        __basisState.lights.forEach(l => {
          l.intensity = __basisState.lightsOn ? l.userData.__baseIntensity : 0;
          if (l.shadow) l.shadow.needsUpdate = true;
        });
        (__basisState.lensMats || []).forEach(m => {
          const on = m.userData && m.userData.__ledKind === 'lens' ? LED_LENS_ON : LED_EMISSIVE_ON;
          m.emissiveIntensity = __basisState.lightsOn ? on : LED_EMISSIVE_OFF;
          m.needsUpdate = true;
        });
        if (__basisState.ledFill) {
          __basisState.ledFill.intensity = __basisState.lightsOn ? 0.12 : 0;
        }

        /* Общее освещение чуть приглушаем, когда горит подсветка: иначе
           её вклад теряется. Надёжнее всего через экспозицию рендера —
           она не зависит от того, где объявлены источники света. */
        try {
          if (typeof window.__baseExposure !== 'number') {
            window.__baseExposure = (renderer.toneMappingExposure || 1);
          }
          const k = __basisState.lightsOn ? 0.85 : 1.0;
          renderer.toneMappingExposure = window.__baseExposure * k;
          console.log('[led] подсветка:', __basisState.lightsOn,
                      '| экспозиция:', renderer.toneMappingExposure.toFixed(3));
        } catch (eGen) { console.warn('[led] не удалось изменить экспозицию:', eGen); }

        /* подсветка пункта меню «Свет» */
        const li = document.getElementById('mnu_light');
        if (li) { li.classList.toggle('selected', __basisState.lightsOn); }
      }
    };
    try { window.__toggleLedLights = toggleLedLights; } catch (eTL) {}

    /* левая иконка подсветки — только если в модели свет есть */
    if (__basisState.lights.length) {
      addButton('mnu_led', '/img/menu/light.png', 'Подсветка', () => toggleLedLights());
    }

    /* пункты «Фурнитура» и «Профили» — тоже только когда есть что показывать */
    if (hardware.length) {
    addButton('mnu_hw', '🔩', 'Крепёж и сборки', () => {
      if (!hardware.length) { console.warn('[hw] в модели нет фурнитуры'); return; }
      __basisState.hardwareShown = !__basisState.hardwareShown;
      /* Прячем/показываем целыми объектами: меши, маркеры крепежа и сборки */
      __basisState.hardware.forEach(m => {
        m.visible = __basisState.hardwareShown;
        m.traverse(ch => { if (ch !== m) { ch.visible = __basisState.hardwareShown; } });
      });
      try { if (window.__explodeSyncTags) { window.__explodeSyncTags(); } } catch (eSyn) {}
      /* подсветка пункта меню: выбран = фурнитура скрыта */
      const hwItem = document.getElementById('mnu_hw');
      if (hwItem) {
        hwItem.classList.toggle('selected', !__basisState.hardwareShown);
        const lb = hwItem.querySelector('span');
        if (lb) { lb.textContent = __basisState.hardwareShown ? 'Скрыть фурнитуру' : 'Показать фурнитуру'; }
      }
      console.log('[hw] фурнитура видна:', __basisState.hardwareShown,
                  '| объектов:', __basisState.hardware.length);
    });
    }

    /* Профили: отдельная кнопка слева — прячет профили вместе с номерами. */
    const profiles = [];
    model.traverse(o => {
      const ud = o.userData || {};
      if (!ud.partId || ud.kind !== 'profile') return;
      if (profiles.indexOf(o) < 0) { profiles.push(o); }
    });

    if (profiles.length) {
    addButton('mnu_prof', '▤', 'Скрыть профили', () => {
      if (!profiles.length) { console.warn('[prof] в модели нет профилей'); return; }
      __basisState.profilesShown = (__basisState.profilesShown === false);
      const vis = __basisState.profilesShown;
      profiles.forEach(o => {
        o.visible = vis;
        o.traverse(ch => { if (ch !== o) { ch.visible = vis; } });
      });
      try { if (window.__explodeSyncTags) { window.__explodeSyncTags(); } } catch (ePr) {}
      const prItem = document.getElementById('mnu_prof');
      if (prItem) {
        prItem.classList.toggle('selected', !vis);
        const lb = prItem.querySelector('span');
        if (lb) { lb.textContent = vis ? 'Скрыть профили' : 'Показать профили'; }
      }
      console.log('[prof] профили видны:', vis, '| штук:', profiles.length);
    });
    }

    /* меню показываем всегда: кнопки есть даже если данных для них нет */
    faceMenu.classList.remove('hidden-field');

    console.log('[basis] фасадов:', facades.length, '| фурнитуры:', hardware.length,
      '| источников света:', lights.length, '| анимаций:', actions.length);
  } catch (e) {
    console.error('[basis] ошибка инициализации данных:', e);
  }
}

// --- Размеры как в Базисе ---------------------------------------------------
// глубина  — слева сверху (вдоль Z, у левой верхней кромки)
// ширина   — сзади сверху (вдоль X, у задней верхней кромки)
// высота   — сзади справа (вдоль Y, у правой задней кромки)
const __dims = { on: false, group: null, labels: [], raf: null, tick: 0 };
const __dimRay = new THREE.Raycaster();
const DIM = { color: 0x111111, out: 0.06, arrow: 0.02, opacity: 0.55 };

function __fmtMm(v) { return Math.round(v * 1000) + ' мм'; }

function __seg(pts, a, b) {
  pts.push(a.x, a.y, a.z, b.x, b.y, b.z);
}

/* стрелка: две короткие линии из острия назад под углом */
function __arrow(pts, tip, dir, perp, s) {
  const back = tip.clone().addScaledVector(dir, -s);
  __seg(pts, tip, back.clone().addScaledVector(perp, s * 0.35));
  __seg(pts, tip, back.clone().addScaledVector(perp, -s * 0.35));
}

function __addLabel(anchor) {
  const el = document.createElement('div');
  el.className = 'dim-label';
  el.textContent = anchor.text;
  el.style.cssText = 'position:fixed;transform:translate(-50%,-50%);background:rgba(255,255,255,.92);' +
    'color:#111;border:1px solid rgba(0,0,0,.25);border-radius:4px;padding:1px 6px;' +
    'font:12px/1.4 system-ui,sans-serif;pointer-events:none;white-space:nowrap;z-index:40';
  document.body.appendChild(el);
  __dims.labels.push({ el, pos: anchor.pos.clone(), occluded: false });
}

function __buildDims() {
  if (!model) return null;

  const group = new THREE.Group();
  group.name = '__dims';
  const mat = new THREE.LineBasicMaterial({
    color: DIM.color, depthTest: true, depthWrite: false, transparent: true, opacity: DIM.opacity
  });
  const pts = [];
  const anchors = [];

  /* 1. Если в GLB пришли размеры из Базиса — рисуем их.
     Важно: TSize3D отдаёт координаты в своей системе (сдвиг ~1880 мм по X,
     ~1170 по Z относительно деталей). Поэтому выравниваем: масштаба нет,
     только перенос, который подбираем по габариту модели. */
  /* extras приходят на дочернем узле (например «basis»), а не на gltf.scene —
     поэтому ищем по всему дереву, иначе вьювер падал в режим габарита */
  let real = model.userData && model.userData.dimensions;
  if (!Array.isArray(real) || !real.length) {
    model.traverse(o => {
      if ((!Array.isArray(real) || !real.length) && o.userData && Array.isArray(o.userData.dimensions)) {
        real = o.userData.dimensions;
      }
    });
  }
  if (Array.isArray(real) && real.length) {
    /* Размеры из Базиса ставим к КОРПУСУ, а не к габариту всей модели:
       иначе любой объект рядом (лед-профиль, полка, декор) сдвигает
       выравнивание, и размеры уезжают. Берём только панели. */
    const box = new THREE.Box3();
    const seenParts = new Set();
    model.traverse(o => {
      const ud = o.userData;
      if (!ud || !ud.partId || seenParts.has(o.uuid)) return;
      if (ud.edge || ud.plastic || ud.outline) return;
      const k = ud.kind || ud.role;
      if (k !== 'panel' && k !== 'contour') return;
      seenParts.add(o.uuid);
      box.expandByObject(o);
    });
    if (box.isEmpty()) { box.setFromObject(model); }
    const min = box.min, max = box.max;
    console.log('[dims] корпус: X', (min.x * 1000).toFixed(0), '..', (max.x * 1000).toFixed(0),
                '| Y', (min.y * 1000).toFixed(0), '..', (max.y * 1000).toFixed(0),
                '| Z', (min.z * 1000).toFixed(0), '..', (max.z * 1000).toFixed(0),
                '| панелей:', seenParts.size);

    const dims = real
      .filter(d => d && d.a && d.b)
      .map(d => ({
        a: new THREE.Vector3(d.a[0] * 0.001, d.a[1] * 0.001, d.a[2] * 0.001),
        b: new THREE.Vector3(d.b[0] * 0.001, d.b[1] * 0.001, d.b[2] * 0.001),
        text: (d.text || Math.round(d.value)) + ' мм',
        rawLen: Math.abs(d.len || 0) * 0.001
      }));
    if (!dims.length) return null;

    /* границы берём ТОЛЬКО по размерам: если подмешать габарит модели,
       сдвиг обнуляется и линии остаются висеть в стороне */
    function dimSpan(axis) {
      let lo = Infinity, hi = -Infinity;
      dims.forEach(d => {
        lo = Math.min(lo, d.a[axis], d.b[axis]);
        hi = Math.max(hi, d.a[axis], d.b[axis]);
      });
      return [lo, hi];
    }

    /* для каждой оси: если есть размер, совпадающий с габаритом, выравниваем
       по обоим концам; иначе прижимаем к наружной грани (по максимуму) */
    /* Модель центрируется вьювером: model.position = −center (см. начало
       файла). Размеры приходят из Базиса в глобальных координатах, поэтому
       к ним применяется РОВНО ТОТ ЖЕ перенос — один вектор на все оси.
       Так сохраняются и отступ 18 мм, и вынос по глубине. */
    const shift = model.position.clone();
    console.log('[dims] перенос модели:', shift.toArray().map(v => Math.round(v * 1000) / 1000).join('/'));

    const v3 = new THREE.Vector3(shift.x, shift.y, shift.z);
    const center = new THREE.Vector3(
      (min.x + max.x) / 2, (min.y + max.y) / 2, (min.z + max.z) / 2
    );

    const EXT = 0.012;    // вынос выносной линии за размер, метры

    dims.forEach(d => {
      if (!d._shifted) { d.a.add(v3); d.b.add(v3); }

      /* len у TSize3D — на сколько размер вынесен наружу от детали.
         Направление наружу не приходит, поэтому берём его по положению:
         та ось, по которой середина размера дальше всего от центра шкафа. */
      const mid = d.a.clone().add(d.b).multiplyScalar(0.5);
      const delta = mid.clone().sub(center);
      const ax = Math.abs(delta.x) >= Math.abs(delta.y) && Math.abs(delta.x) >= Math.abs(delta.z)
        ? 'x' : (Math.abs(delta.y) >= Math.abs(delta.z) ? 'y' : 'z');
      const dirOut = Math.sign(delta[ax]) || 1;

      const baseA = d.a.clone();     // точки на детали
      const baseB = d.b.clone();
      const off = Math.abs(d.rawLen || 0);
      const push = new THREE.Vector3();
      if (off > 0) {
        push[ax] = dirOut * off;
        d.a.add(push);
        d.b.add(push);
      }

      /* выносные линии: от детали до линии размера, с небольшим выступом */
      const outDir = new THREE.Vector3();
      outDir[ax] = dirOut;
      const over = off + EXT;
      __seg(pts, baseA, baseA.clone().addScaledVector(outDir, over));
      __seg(pts, baseB, baseB.clone().addScaledVector(outDir, over));

      __seg(pts, d.a, d.b);
      const dir = d.b.clone().sub(d.a);
      if (dir.lengthSq() < 1e-9) return;
      dir.normalize();
      const perp = Math.abs(dir.y) > 0.9 ? new THREE.Vector3(0, 0, 1) : new THREE.Vector3(0, 1, 0);
      __arrow(pts, d.a, dir.clone().negate(), perp, DIM.arrow);
      __arrow(pts, d.b, dir, perp, DIM.arrow);

      anchors.push({
        text: d.text,
        pos: d.a.clone().add(d.b).multiplyScalar(0.5)
      });
    });

    const geoR = new THREE.BufferGeometry();
    geoR.setAttribute('position', new THREE.Float32BufferAttribute(pts, 3));
    /* depthTest включён: размеры за шкафом перекрываются моделью.
       Линия в WebGL всегда 1 px, поэтому «тоньше» делаем полупрозрачностью. */
    const lineMat = new THREE.LineBasicMaterial({
      color: DIM.color,
      depthTest: true,
      depthWrite: false,
      transparent: true,
      opacity: DIM.opacity
    });
    const linesR = new THREE.LineSegments(geoR, lineMat);
    group.add(linesR);

    anchors.forEach(__addLabel);
    /* ВАЖНО: точки размеров уже в мировых координатах (Box3 по модели).
       Модель сдвинута на -center, поэтому вешать группу на model нельзя —
       сдвиг применился бы дважды и размеры уехали влево-вниз. */
    scene.add(group);
    window.__basisDimGroup = group;
    group.userData.dimGroup = true;
    console.log('[dims] размеров из Базиса:', anchors.length);
    return group;
  }

  /* 2. Иначе — габарит, но по сторонам как в Базисе */
  const box = new THREE.Box3().setFromObject(model);
  const minX = box.min.x, maxX = box.max.x;
  const minY = box.min.y, maxY = box.max.y;
  const minZ = box.min.z, maxZ = box.max.z;
  const OUT = DIM.out;

  // глубина: над шкафом, вдоль Z (без сдвига влево — как в Базисе)
  {
    const x = minX, y = maxY + OUT;
    const a = new THREE.Vector3(x, y, minZ);
    const b = new THREE.Vector3(x, y, maxZ);
    __seg(pts, a, b);
    __arrow(pts, a, new THREE.Vector3(0, 0, -1), new THREE.Vector3(0, 1, 0), DIM.arrow);
    __arrow(pts, b, new THREE.Vector3(0, 0, 1), new THREE.Vector3(0, 1, 0), DIM.arrow);
    __seg(pts, new THREE.Vector3(minX, maxY, minZ), a);
    __seg(pts, new THREE.Vector3(minX, maxY, maxZ), b);
    anchors.push({ text: __fmtMm(maxZ - minZ), pos: new THREE.Vector3(x, y, (minZ + maxZ) / 2) });
  }

  // ширина: сверху у задней плоскости, вдоль X (без сдвига назад)
  {
    const z = minZ, y = maxY + OUT;
    const a = new THREE.Vector3(minX, y, z);
    const b = new THREE.Vector3(maxX, y, z);
    __seg(pts, a, b);
    __arrow(pts, a, new THREE.Vector3(-1, 0, 0), new THREE.Vector3(0, 1, 0), DIM.arrow);
    __arrow(pts, b, new THREE.Vector3(1, 0, 0), new THREE.Vector3(0, 1, 0), DIM.arrow);
    __seg(pts, new THREE.Vector3(minX, maxY, minZ), a);
    __seg(pts, new THREE.Vector3(maxX, maxY, minZ), b);
    anchors.push({ text: __fmtMm(maxX - minX), pos: new THREE.Vector3((minX + maxX) / 2, y, z) });
  }

  // высота: справа у задней плоскости, вдоль Y (без сдвига назад)
  {
    const x = maxX + OUT, z = minZ;
    const a = new THREE.Vector3(x, minY, z);
    const b = new THREE.Vector3(x, maxY, z);
    __seg(pts, a, b);
    __arrow(pts, a, new THREE.Vector3(0, -1, 0), new THREE.Vector3(0, 0, 1), DIM.arrow);
    __arrow(pts, b, new THREE.Vector3(0, 1, 0), new THREE.Vector3(0, 0, 1), DIM.arrow);
    __seg(pts, new THREE.Vector3(maxX, minY, minZ), a);
    __seg(pts, new THREE.Vector3(maxX, maxY, minZ), b);
    anchors.push({ text: __fmtMm(maxY - minY), pos: new THREE.Vector3(x, (minY + maxY) / 2, z) });
  }

  const geo = new THREE.BufferGeometry();
  geo.setAttribute('position', new THREE.Float32BufferAttribute(pts, 3));
  group.add(new THREE.LineSegments(geo, mat));
  anchors.forEach(__addLabel);

  scene.add(group);
  console.log('[dims] габарит: глубина слева сверху, ширина сзади сверху, высота сзади справа');
  return group;
}

function __updateDims() {
  if (!__dims.on) return;
  const rect = renderer.domElement.getBoundingClientRect();
  const v = new THREE.Vector3();

  /* Подписи — это HTML поверх канваса, глубина их не скрывает. Поэтому раз
     в 4 кадра пускаем луч из камеры в точку подписи: если по дороге есть
     геометрия, подпись прячем — как и линию за моделью. */
  __dims.tick = (__dims.tick + 1) % 4;
  /* В разборе детали разъехались — проверка перекрытия начинает гасить
     подписи размеров пачками. Пока разбор включён, перекрытие не считаем. */
  /* После первого применения разбора детали перепакованы в обёртки, и луч
     начинает «находить» геометрию на пути к подписи — все подписи гасятся.
     Поэтому после разбора проверку перекрытия не считаем вообще. */
  const checkOcclusion = __dims.tick === 0 && !!model &&
                         !window.__explodeOn && !window.__explodeUsed;

  __dims.labels.forEach(l => {
    if (checkOcclusion) {
      const dir = l.pos.clone().sub(camera.position);
      const dist = dir.length();
      if (dist > 1e-4) {
        __dimRay.set(camera.position, dir.normalize());
        __dimRay.near = 0.01;
        __dimRay.far = Math.max(0.02, dist - 0.01);
        l.occluded = __dimRay.intersectObject(model, true).length > 0;
      }
    }

    /* Пока разбор включён, перекрытие не считается — значит старый флаг
       «перекрыт» недействителен и его надо сбросить, иначе подпись остаётся
       скрытой навсегда. */
    if (window.__explodeOn) { l.occluded = false; }

    v.copy(l.pos).project(camera);
    const visible = v.z < 1 && !l.occluded;
    l.el.style.display = visible ? 'block' : 'none';
    l.el.style.left = ((v.x * 0.5 + 0.5) * rect.width) + 'px';
    l.el.style.top = ((-v.y * 0.5 + 0.5) * rect.height) + 'px';
  });
  __dims.raf = requestAnimationFrame(__updateDims);
}

function toggleDimensions() {
  if (!model) return;
  __dims.on = !__dims.on;

  if (__dims.on) {
    if (!__dims.group) __dims.group = __buildDims();
    if (__dims.group) __dims.group.visible = true;
    __dims.labels.forEach(l => { l.occluded = false; l.el.style.display = 'block'; });
    if (window.__explodeUsed) { window.__explodeOn = false; }
    __updateDims();
  } else {
    if (__dims.raf) { cancelAnimationFrame(__dims.raf); __dims.raf = null; }
    if (__dims.group) __dims.group.visible = false;
    __dims.labels.forEach(l => { l.el.style.display = 'none'; });
  }

  /* Диагностика подписей: сколько их, живы ли DOM-элементы, что с видимостью */
  try {
    const alive = __dims.labels.filter(l => l.el && l.el.isConnected).length;
    const shown = __dims.labels.filter(l => l.el && l.el.style.display !== 'none').length;
    const occ = __dims.labels.filter(l => l.occluded).length;
    console.log('[dims] on=' + __dims.on, '| подписей=' + __dims.labels.length,
                '| в DOM=' + alive, '| показано=' + shown, '| перекрыто=' + occ,
                '| explode=' + !!window.__explodeOn, '| группа=' + (__dims.group ? __dims.group.visible : 'нет'));
  } catch (eDg2) {}

  const item = document.getElementById('mnu_dims');
  if (item) item.classList.toggle('selected', __dims.on);
}

/* ---------------------------------------------------------------------------
   Иконки кнопок левой колонки — PNG-файлы из /img/menu/. Их можно заменить
   своими: достаточно положить картинку того же имени (квадратную, прозрачный
   фон, тёмный рисунок — под светлую кнопку).
   Путь считаем иконкой, если он похож на файл картинки. */
function __isIconPath(s) {
  return typeof s === 'string' && /(^\/|^data:|^https?:).*\.(png|svg|webp)(\?|$)/i.test(s);
}

function __setMenuIcon(btn, url, altText) {
  if (!btn) return;
  while (btn.firstChild) { btn.removeChild(btn.firstChild); }
  const img = document.createElement('img');
  img.className = 'mnu-png';
  img.src = url;
  img.alt = altText || '';
  img.draggable = false;
  btn.appendChild(img);
  btn.dataset.icon = url;
  /* класс, а не inline-стиль: правило в CSS действует на все такие кнопки */
  btn.classList.add('menu-icon-btn');
}

function initDimensionsButton() {
  const faceMenu = document.getElementById('face_menu');
  if (!faceMenu || document.getElementById('mnu_dims')) return;
  const b = document.createElement('button');
  b.id = 'mnu_dims';
  b.className = 'menu-faces';
  b.dataset.tooltip = 'Размеры';
  b.title = 'Размеры';
  __setMenuIcon(b, '/img/menu/ruler.png', 'Размеры');
  b.addEventListener('click', toggleDimensions);
  faceMenu.appendChild(b);
  faceMenu.classList.remove('hidden-field');
}

/* ------------------------------- Комната ----------------------------------
   Пол 10×5 м и стена 2.7 м с плинтусом — чтобы изделие было видно «в
   интерьере» и читался масштаб. Сама геометрия лежит в js/app/room.js:
   её можно проверить тестом без браузера (tests/room.test.mjs).
   Кнопка «Комната» — в левой колонке, сразу под «Размеры»; по нажатию
   раскрывается меню из трёх строк: левый угол / центр / правый угол. */
const __room = { on: false, group: null, anchor: null };
const ROOM_ANCHORS = [
  ['left', 'Левый угол'],
  ['center', 'Центр'],
  ['right', 'Правый угол']
];

function __syncRoomMenu() {
  const btn = document.getElementById('mnu_room');
  if (btn) { btn.classList.toggle('selected', __room.on); }
  const items = document.querySelectorAll('.room-menu-item');
  for (let i = 0; i < items.length; i++) {
    const it = items[i];
    it.classList.toggle('selected', __room.on && it.dataset.anchor === __room.anchor);
  }
}

function __clearRoom() {
  const B = window.__roomBuilder;
  if (__room.group) {
    try { scene.remove(__room.group); } catch (e) {}
    try { if (B && B.disposeRoom) { B.disposeRoom(__room.group); } } catch (e) {}
  }
  __room.group = null;
  __room.on = false;
  __room.anchor = null;
  __syncRoomMenu();
}

/* Выбор в меню: строит комнату с нужной привязкой. Повторный выбор того же
   пункта выключает комнату (отдельной строки «выключить» в меню нет). */
function setRoomAnchor(anchor) {
  const wrap = document.getElementById('room_menu');
  if (wrap) { wrap.classList.remove('open'); }
  if (__room.on && __room.anchor === anchor) { __clearRoom(); return; }

  __clearRoom();
  const B = window.__roomBuilder;
  if (!B || typeof B.buildRoom !== 'function') {
    console.warn('[viewer] модуль комнаты не подключился (js/app/room.js)');
    return;
  }
  try {
    const group = B.buildRoom(model, { anchor: anchor });
    if (!group) { return; }
    scene.add(group);
    __room.group = group;
    __room.on = true;
    __room.anchor = anchor;
    __syncRoomMenu();
    const ud = group.userData || {};
    if (ud.box) {
      console.log('[viewer] комната: ' + B.ROOM.W + '×' + B.ROOM.D + ' м, стена ' + B.ROOM.H +
                  ' м, привязка ' + anchor + ', низ изделия y=' + ud.box.min.y.toFixed(2));
    }
  } catch (e) {
    console.warn('[viewer] комната не создалась:', e && e.message ? e.message : e);
  }
}

/* Кнопка в левой колонке: клик раскрывает/закрывает меню. */
function toggleRoom() {
  const wrap = document.getElementById('room_menu');
  if (!wrap) { return; }
  wrap.classList.toggle('open');
}

function initRoomButton() {
  const faceMenu = document.getElementById('face_menu');
  if (!faceMenu || document.getElementById('mnu_room')) { return; }

  const wrap = document.createElement('div');
  wrap.className = 'room-menu';
  wrap.id = 'room_menu';

  const b = document.createElement('button');
  b.id = 'mnu_room';
  b.className = 'menu-faces';
  b.type = 'button';
  b.dataset.tooltip = 'Комната: пол 10×5 м, стена 2.7 м';
  b.title = 'Комната: пол 10×5 м, стена 2.7 м с плинтусом';
  __setMenuIcon(b, '/img/menu/room.png', 'Комната');

  const list = document.createElement('div');
  list.className = 'room-menu-list';
  ROOM_ANCHORS.forEach((pair) => {
    const it = document.createElement('button');
    it.type = 'button';
    it.className = 'room-menu-item';
    it.dataset.anchor = pair[0];
    it.textContent = pair[1];
    it.addEventListener('click', (ev) => {
      ev.stopPropagation();
      setRoomAnchor(pair[0]);
    });
    list.appendChild(it);
  });

  b.addEventListener('click', (ev) => {
    ev.stopPropagation();
    toggleRoom();
  });
  /* клик мимо меню или Esc — закрыть список */
  document.addEventListener('click', () => {
    const w = document.getElementById('room_menu');
    if (w) { w.classList.remove('open'); }
  });
  document.addEventListener('keydown', (ev) => {
    if (ev.key !== 'Escape') { return; }
    const w = document.getElementById('room_menu');
    if (w) { w.classList.remove('open'); }
  });

  wrap.appendChild(b);
  wrap.appendChild(list);

  /* строго под «Размеры» */
  const dims = document.getElementById('mnu_dims');
  if (dims && dims.parentNode === faceMenu) { faceMenu.insertBefore(wrap, dims.nextSibling); }
  else { faceMenu.appendChild(wrap); }
  faceMenu.classList.remove('hidden-field');
}

// «Скрыть фасады»: двери просто исчезают, корпус остаётся как есть.
// Для моделей Базиса фасады опознаны по role (см. приведение выше),
// для OBJ — по именам материалов Fasad1..3, как было.
// --- Режим «Сетчатый»: только рёбра панелей, фурнитура и отверстия -----------
const __edges = { on: false, items: [] };

function __buildEdges() {
  const mat = new THREE.LineBasicMaterial({
    color: 0x1f1f1f, transparent: true, opacity: 0.75, depthTest: false
  });

  const meshes = [];
  model.traverse(o => {
    if (!o.isMesh || !o.geometry) return;
    /* отверстия и крепёж не превращаем в рёбра — они и так линии/кружки */
    if (o.userData && o.userData.role === 'hole') return;
    if (!o.visible) return;          /* скрытые фасады рёбер не дают */
    if (o.userData && o.userData.contour) {
      /* у панели с вырезом рёбра треугольников дают ложные линии —
         показываем заранее построенный настоящий контур */
      o.children.forEach(ch => {
        if (ch.userData && ch.userData.outline) {
          ch.visible = true;
          ch.frustumCulled = false;
          o.updateMatrixWorld(true);
          model.attach(ch);              /* контур тоже выносим из панели */
          __edges.items.push({ line: ch, mesh: o, outline: true });
        }
      });
      o.visible = false;
      return;
    }
    meshes.push(o);
  });

  /* Своя сборка «сетки». Штатная EdgesGeometry берёт первые два треугольника
     на ребре, а у нас грани продублированы в обе стороны — она видит угол
     180° и рисует лишнее. Здесь из всех пар выбирается минимальный угол. */
  function __edgeGeometry(geo, thresholdDeg, minLen) {
    const P = geo.attributes.position;
    if (!P) return null;
    const idx = geo.index;
    const triCount = idx ? Math.floor(idx.count / 3) : Math.floor(P.count / 3);
    if (!triCount) return null;

    const vmap = new Map();
    const verts = [];
    const tri = new Int32Array(triCount * 3);
    const vkey = (x, y, z) => Math.round(x * 100) + ',' + Math.round(y * 100) + ',' + Math.round(z * 100);

    for (let t = 0; t < triCount; t++) {
      for (let k = 0; k < 3; k++) {
        /* ВАЖНО: у BufferAttribute НЕТ числовых индексов — читать только
           через getX(). Иначе в вершины попадает undefined и вся геометрия
           получается с NaN. */
        const vi = idx ? idx.getX(t * 3 + k) : (t * 3 + k);
        const x = P.getX(vi), y = P.getY(vi), z = P.getZ(vi);
        const key = vkey(x, y, z);
        let id = vmap.get(key);
        if (id === undefined) { id = verts.length / 3; verts.push(x, y, z); vmap.set(key, id); }
        tri[t * 3 + k] = id;
      }
    }

    const nrmArr = new Float32Array(triCount * 3);
    for (let t = 0; t < triCount; t++) {
      const a = tri[t * 3] * 3, b = tri[t * 3 + 1] * 3, c = tri[t * 3 + 2] * 3;
      const ux = verts[b] - verts[a], uy = verts[b + 1] - verts[a + 1], uz = verts[b + 2] - verts[a + 2];
      const vx = verts[c] - verts[a], vy = verts[c + 1] - verts[a + 1], vz = verts[c + 2] - verts[a + 2];
      let nx = uy * vz - uz * vy, ny = uz * vx - ux * vz, nz = ux * vy - uy * vx;
      const L = Math.hypot(nx, ny, nz) || 1;
      nrmArr[t * 3] = nx / L; nrmArr[t * 3 + 1] = ny / L; nrmArr[t * 3 + 2] = nz / L;
    }

    const em = new Map();
    for (let t = 0; t < triCount; t++) {
      for (let k = 0; k < 3; k++) {
        const a = tri[t * 3 + k], b = tri[t * 3 + (k + 1) % 3];
        const key = a < b ? (a + '_' + b) : (b + '_' + a);
        let arr = em.get(key);
        if (!arr) { arr = []; em.set(key, arr); }
        if (arr.length < 8) arr.push(t);
      }
    }

    const thr = Math.cos(thresholdDeg * Math.PI / 180);
    const out = [];
    em.forEach((list, key) => {
      const parts = key.split('_');
      const ia = Number(parts[0]) * 3, ib = Number(parts[1]) * 3;
      const ax = verts[ia], ay = verts[ia + 1], az = verts[ia + 2];
      const bx = verts[ib], by = verts[ib + 1], bz = verts[ib + 2];
      if (Math.hypot(bx - ax, by - ay, bz - az) < minLen) return;

      let keep = list.length === 1;
      if (list.length >= 2) {
        let maxDot = -2;
        for (let i = 0; i < list.length; i++) {
          for (let j = i + 1; j < list.length; j++) {
            const a3 = list[i] * 3, b3 = list[j] * 3;
            const d = nrmArr[a3] * nrmArr[b3] + nrmArr[a3 + 1] * nrmArr[b3 + 1] + nrmArr[a3 + 2] * nrmArr[b3 + 2];
            if (d > maxDot) maxDot = d;    /* самая «плоская» пара */
          }
        }
        keep = maxDot < thr;
      }
      if (keep) out.push(ax, ay, az, bx, by, bz);
    });

    if (!out.length) return null;
    const g2 = new THREE.BufferGeometry();
    g2.setAttribute('position', new THREE.Float32BufferAttribute(out, 3));
    return g2;
  }

  /* Отсекаем совсем короткие рёбра. У канавки на торце профиль даёт
     десятки линий по 1–2 мм — на фасаде это выглядит как штриховка.
     Порог относительный: 0.5 % наибольшего размера детали, в пределах 1…6 мм. */
  function __filterShortEdges(eg, geo) {
    const pos = eg.attributes.position;
    if (!pos) return eg;
    let maxDim = 1;
    try {
      geo.computeBoundingBox();
      const bb = geo.boundingBox;
      if (bb) {
        const sx = bb.max.x - bb.min.x, sy = bb.max.y - bb.min.y, sz = bb.max.z - bb.min.z;
        maxDim = Math.max(sx, sy, sz) || 1;
      }
    } catch (e) {}
    const thr = Math.min(6, Math.max(1, maxDim * 0.005));

    const keep = [];
    const a = new THREE.Vector3(), b = new THREE.Vector3();
    for (let i = 0; i + 1 < pos.count; i += 2) {
      a.fromBufferAttribute(pos, i);
      b.fromBufferAttribute(pos, i + 1);
      if (a.distanceTo(b) >= thr) { keep.push(i, i + 1); }
    }
    if (keep.length === pos.count || keep.length === 0) return eg;

    const out = new THREE.BufferGeometry();
    const arr = new Float32Array(keep.length * 3);
    for (let k = 0; k < keep.length; k++) {
      const i = keep[k];
      arr[k * 3] = pos.getX(i); arr[k * 3 + 1] = pos.getY(i); arr[k * 3 + 2] = pos.getZ(i);
    }
    out.setAttribute('position', new THREE.BufferAttribute(arr, 3));
    try { eg.dispose(); } catch (e) {}
    return out;
  }

  meshes.forEach(o => {
    let eg = null;
    try {
      let maxDim = 1;
      o.geometry.computeBoundingBox();
      const bb = o.geometry.boundingBox;
      if (bb) {
        maxDim = Math.max(bb.max.x - bb.min.x, bb.max.y - bb.min.y, bb.max.z - bb.min.z) || 1;
      }
      const minLen = Math.min(6, Math.max(1, maxDim * 0.005));
      eg = __edgeGeometry(o.geometry, 14, minLen);
    } catch (e) { return; }
    if (!eg || !eg.attributes.position || eg.attributes.position.count === 0) return;

    const line = new THREE.LineSegments(eg, mat);
    line.visible = true;
    line.frustumCulled = false;
    line.renderOrder = 5;
    /* Кладём линию сначала в деталь, потом переносим в модель через attach:
       он сам пересчитывает мировую матрицу, поэтому линия встаёт ровно на
       деталь при любой цепочке родителей. */
    o.add(line);
    o.updateMatrixWorld(true);
    model.attach(line);
    __edges.items.push({ line: line, mesh: o });
    o.visible = false;
  });
}

function __edgesDiagnostics() {
  let withGeo = 0, withoutGeo = 0;
  model.traverse(o => {
    if (!o.isMesh || !o.geometry) return;
    if (o.userData && o.userData.role === 'hole') return;
    withGeo++;
  });
  console.log('[edges] мешей:', withGeo, '| линий:', __edges.items.length);
  __edges.items.slice(0, 3).forEach(it => {
    const g = it.line.geometry;
    const c = g && g.attributes && g.attributes.position ? g.attributes.position.count : 0;
    console.log('[edges] линия: точек', c, '| видима', it.line.visible,
                '| узел', it.line.parent && it.line.parent.type);
  });
}

function __clearEdges() {
  __edges.items.forEach(it => {
    it.mesh.visible = true;
    if (it.mesh.layers) { it.mesh.layers.set(0); }
    if (it.outline) {
      it.line.visible = false;      /* контур детали не удаляем */
      /* возвращаем контур обратно в панель (через attach — с сохранением
         мирового положения детали) */
      if (it.line.parent && it.line.parent !== it.mesh) {
        it.mesh.updateMatrixWorld(true);
        it.mesh.attach(it.line);
      }
      return;
    }
    if (it.line.parent) it.line.parent.remove(it.line);
    if (it.line.geometry) it.line.geometry.dispose();
  });
  __edges.items.length = 0;
}

// --- Полупрозрачный режим: текстуры остаются, панели просвечивают -----------
const __alpha = { on: false, mats: new Map() };

function __panelMeshes() {
  const list = [];
  model.traverse(o => {
    if (!o.isMesh) return;
    const ud = o.userData || {};

    /* kind ищем и у предков: панель с несколькими материалами (пласть + торцы)
       в glTF превращается в ГРУППУ, и признак «панель» может лежать на группе,
       а не на дочернем меше. Из-за этого обычные панели не попадали в
       прозрачный режим, а детали из Базиса (у них один материал) — попадали. */
    let kind = ud.kind || null;
    if (!kind) {
      let cur = o.parent;
      while (cur && cur !== model) {
        if (cur.userData && cur.userData.kind) { kind = cur.userData.kind; break; }
        cur = cur.parent;
      }
    }

    /* панели, кромка и плёнка; фурнитуру и профили не трогаем */
    if (kind === 'panel' || ud.edge || ud.plastic) list.push(o);
  });
  return list;
}

function toggleAlpha() {
  if (!model) return;
  __alpha.on = !__alpha.on;

  /* Панели + кромки и облицовка: у них СВОЙ материал, и в прозрачном режиме
     его тоже надо перевести на односторонний — иначе обратные грани кромки
     мерцают на плоскости панели. */
  const extraMeshes = [];
  model.traverse(o => {
    if (!o.isMesh || !o.userData) return;
    if (o.userData.edge || o.userData.plastic) { extraMeshes.push(o); }
  });
  const meshes = __panelMeshes().concat(extraMeshes);

  if (__alpha.on) {
    __alpha.mats.clear();
    meshes.forEach(o => {
      const mats = Array.isArray(o.material) ? o.material : [o.material];
      mats.forEach(m => {
        if (!m || __alpha.mats.has(m)) return;
        __alpha.mats.set(m, {
          transparent: m.transparent,
          opacity: m.opacity,
          depthWrite: m.depthWrite,
          map: m.map,
          side: m.side,
          polygonOffset: m.polygonOffset,
          polygonOffsetFactor: m.polygonOffsetFactor,
          polygonOffsetUnits: m.polygonOffsetUnits
        });
        m.transparent = true;
        m.opacity = 0.45;
        m.depthWrite = false;          // чтобы прозрачные панели не перекрывали друг друга

        /* В прозрачном режиме отключаем двусторонность: обратные грани
           кромки, плёнки и фурнитуры стоят в одной плоскости с лицевыми
           и мерцают. Плюс отодвигаем прозрачную геометрию по глубине. */
        m.side = THREE.FrontSide;

        if (m.map) { m.map.needsUpdate = true; }   // текстура остаётся как была
        m.needsUpdate = true;
      });
    });
  } else {
    __alpha.mats.forEach((orig, m) => {
      m.transparent = orig.transparent;
      m.opacity = orig.opacity;
      m.depthWrite = orig.depthWrite;
      if (orig.side !== undefined) { m.side = orig.side; }
      m.polygonOffset = orig.polygonOffset;
      m.polygonOffsetFactor = orig.polygonOffsetFactor;
      m.polygonOffsetUnits = orig.polygonOffsetUnits;
      m.needsUpdate = true;
    });
    __alpha.mats.clear();
  }

  /* Линии сетки лежат ровно на поверхности, поэтому в прозрачном режиме
     они дают неустранимое мерцание (спор за глубину). Прячем их на время
     режима и возвращаем при выключении — так честно и предсказуемо. */
  try {
    (__edges.items || []).forEach(it => {
      const ln = it.line;
      if (!ln) return;
      ln.visible = __alpha.on ? false : true;
    });
  } catch (eEd) {}

  const item = document.getElementById('mnu_alpha');
  if (item) item.classList.toggle('selected', __alpha.on);
  console.log('[viewer] полупрозрачный режим:', __alpha.on, '| материалов:', __alpha.mats.size);
}



/* Признак фасада: роль детали из Базиса, имя материала Fasad* у старых
   OBJ-моделей либо имя самой детали со словом «Дверь»/«дверца» — в Базесе
   дверцы часто приходят без роли фасада, и раньше кнопка их не находила. */
/* ---------------------- ФАСАДЫ (полупрозрачность) ------------------------ */
/* OBJ: фасад — МАТЕРИАЛ Fasad1/Fasad2/Fasad3 или параметр MTL «Fasad N»
        (mat.userData.fasade). Затемнение делает setXRayMode().
   Базис: фасад — ДЕТАЛЬ, в названии которой есть «Фасад» или «Дверь»
        («Ш1.Фасад», «ГШ.Фасад», «Фасад шкафа», «Дверь»). Деталь скрывается
        целиком, вместе со всеми вложенными мешами. */

const FASAD_PATTERNS = ['Fasad1', 'Fasad2', 'Fasad3'];
const __BASIS_FASAD_RX = /фасад|двер/i;
let __facesOn = false;
let __basisFacadeCache = null;

function __nodeName(o) {
  const ud = o.userData || {};
  return String(ud.name || o.name || '');
}

/* Узлы-детали, которые надо скрывать: имя подходит И нет предка с подходящим
   именем (иначе скроем всю группу). Работает без partId — имена в GLB лежат
   на узлах деталей, а не на мешах. */
function __basisFacadeNodes() {
  if (__basisFacadeCache) return __basisFacadeCache;

  const matched = [];
  let named = 0;

  if (model) {
    model.traverse((o) => {
      const nm = __nodeName(o);
      if (!nm) return;
      named++;
      if (!__BASIS_FASAD_RX.test(nm)) return;

      /* пропускаем, если выше уже есть подходящий узел */
      let cur = o.parent, nested = false;
      while (cur && cur !== model) {
        if (__BASIS_FASAD_RX.test(__nodeName(cur))) { nested = true; break; }
        cur = cur.parent;
      }
      if (!nested) { matched.push(o); }
    });
  }

  let meshes = 0;
  matched.forEach((o) => { o.traverse((c) => { if (c.isMesh) meshes++; }); });

  __basisFacadeCache = {
    nodes: matched,
    named,
    meshes,
    samples: matched.slice(0, 6).map(__nodeName)
  };
  return __basisFacadeCache;
}

function __facadesFound() {
  if (!model) return false;
  if (window.__modelHasParts) { return __basisFacadeNodes().nodes.length > 0; }

  let found = false;
  model.traverse((child) => {
    if (found || !child.isMesh) return;
    const mats = Array.isArray(child.material) ? child.material : [child.material];
    for (const mat of mats) {
      if (!mat) continue;
      const byName = mat.name && FASAD_PATTERNS.some((pt) => mat.name.includes(pt));
      const byMtl = mat.userData && mat.userData.fasade == 1;
      if (byName || byMtl) { found = true; break; }
    }
  });
  return found;
}

function __basisFacesHide(on) {
  const info = __basisFacadeNodes();
  info.nodes.forEach((o) => { o.visible = !on; });
  return { parts: info.nodes.length, objects: info.nodes.length, meshes: info.meshes };
}

function toggleFaces() {
  if (!model) return;

  if (!__facadesFound()) {
    console.warn('[facades] фасады не найдены:',
      window.__modelHasParts ? 'искали детали «Фасад»/«Дверь»' : 'искали материалы Fasad1..3 / MTL «Fasad N»');
    return;
  }

  __facesOn = !__facesOn;

  let info = '';
  if (!window.__modelHasParts) {
    /* ровно то поведение, что работало раньше для OBJ */
    setXRayMode(__facesOn, FASAD_PATTERNS);
    info = 'материалы Fasad1..3 / MTL «Fasad N»';
  } else {
    const res = __basisFacesHide(__facesOn);
    info = 'детали «Фасад»/«Дверь»: деталей ' + res.parts + ', мешей ' + res.meshes;
  }

  if (typeof __edges !== 'undefined' && __edges.on) {
    try { __clearEdges(); __buildEdges(); } catch (eEg) {}
  }

  const item = document.getElementById('mnu_fasad');
  if (item) {
    item.classList.toggle('selected', __facesOn);
    const label = item.querySelector('span');
    if (label) { label.textContent = __facesOn ? 'Показать фасады' : 'Скрыть фасады'; }
  }

  const what = window.__modelHasParts
    ? (__facesOn ? 'фасады скрыты' : 'фасады показаны')
    : (__facesOn ? 'фасады прозрачные' : 'фасады обычные');
  console.log('[facades]', what, '|', info);
}

/* ---------------------- ПОИСК ДЕТАЛИ ПО ПОЗИЦИИ ------------------------- */
/* Ищем деталь по номеру позиции (ArtPos), обозначению или имени. Найденная
   подсвечивается толстыми жёлтыми линиями (как выбранный пункт меню),
   включается полупрозрачный режим, а над деталью появляется плашка с номером —
   та же, что рисуется при «Взрыве». */

const __find = { panel: null, group: null, tag: null, sprite: null, input: null };

function __findParts() {
  const out = [];
  if (!model) return out;
  const seen = new Set();
  model.traverse(o => {
    const ud = o.userData || {};
    if (!ud.partId || seen.has(ud.partId)) return;
    /* берём только верхние объекты своей детали */
    let cur = o.parent, nested = false;
    while (cur && cur !== model) {
      if (cur.userData && cur.userData.partId === ud.partId) { nested = true; break; }
      cur = cur.parent;
    }
    if (nested) return;
    seen.add(ud.partId);
    out.push({
      obj: o,
      pos: String(ud.position || '').trim(),
      des: String(ud.designation || '').trim(),
      name: String(ud.name || '').trim(),
      id: String(ud.partId || '').trim()
    });
  });
  return out;
}

function __clearFindHighlight() {
  /* Линии жёлтой обводки добавлены ДЕТЬМИ мешей детали — убираем их по метке,
     иначе после закрытия поиска они остаются висеть. */
  const junk = [];
  /* ВАЖНО: model — переменная модуля, а НЕ свойство window. Проверка
     window.model всегда ложная, и линии не удалялись — жёлтая обводка
     оставалась висеть после закрытия поиска. */
  try {
    if (typeof model !== 'undefined' && model) {
      model.traverse(o => { if (o.userData && o.userData.__findLine) junk.push(o); });
    }
  } catch (eTr) {}
  for (const o of junk) {
    if (o.parent) o.parent.remove(o);
    if (o.geometry) o.geometry.dispose();
  }

  if (__find.group) {
    if (__find.group.parent) { __find.group.parent.remove(__find.group); }
    __find.group.traverse(o => { if (o.geometry) o.geometry.dispose(); });
    __find.group = null;
  }
  if (__find.sprite) {
    if (__find.sprite.parent) { __find.sprite.parent.remove(__find.sprite); }
    if (__find.sprite.material && __find.sprite.material.map) { __find.sprite.material.map.dispose(); }
    __find.sprite = null;
  }
}

function __highlightPart(obj, text) {
  __clearFindHighlight();
  if (!obj) return;

  /* «Толщина» линии: WebGL рисует 1 px, поэтому кладём 5 копий рёбер со
     сдвигом в локальных координатах (детали в миллиметрах). */
  const mat = new THREE.LineBasicMaterial({
    color: 0xE3BD33, transparent: true, opacity: 0.95, depthTest: false, depthWrite: false
  });
  const group = new THREE.Group();
  group.name = '__findHighlight';
  /* Копий много и по кругу: линия в WebGL всегда 1 px, поэтому «толщина»
     набирается наложением сдвинутых копий. Радиус в локальных миллиметрах. */
  const LINE_R = 1.8;
  const offsets = [[0, 0, 0]];
  for (let i = 0; i < 12; i++) {
    const a = (Math.PI * 2 * i) / 12;
    offsets.push([Math.cos(a) * LINE_R, Math.sin(a) * LINE_R, 0]);
    offsets.push([Math.cos(a) * LINE_R * 0.5, Math.sin(a) * LINE_R * 0.5, 0]);
  }

  const meshes = [];
  obj.traverse(o => { if (o.isMesh && o.geometry) meshes.push(o); });

  for (const m of meshes) {
    let eg = null;
    try { eg = new THREE.EdgesGeometry(m.geometry, 25); } catch (eEg) { eg = null; }
    if (!eg || !eg.attributes.position || !eg.attributes.position.count) continue;
    for (const [dx, dy, dz] of offsets) {
      const g2 = eg.clone();
      g2.translate(dx, dy, dz);
      const line = new THREE.LineSegments(g2, mat);
      line.renderOrder = 30;
      line.frustumCulled = false;
      line.userData = { __findLine: true };
      m.add(line);          /* ребёнком детали — трансформация наследуется */
    }
    eg.dispose();
  }
  __find.group = group;     /* за-group держимся только для уборки тегов линий */

  /* Плашка с номером над деталью — как при «Взрыве» */
  try {
    const box = new THREE.Box3().setFromObject(obj);
    if (!box.isEmpty() && typeof window.__explodeMakeTag === 'function') {
      const c = box.getCenter(new THREE.Vector3());
      const spr = window.__explodeMakeTag(text);
      const size = box.getSize(new THREE.Vector3()).length() || 1;
      spr.position.set(c.x, box.max.y + size * 0.08, c.z);
      spr.scale.multiplyScalar(1.1);
      scene.add(spr);
      __find.sprite = spr;
    }
  } catch (eTag) {}

  console.log('[find] подсвечена деталь:', text);
}

function __doFindPart(query) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return;
  const parts = __findParts();
  const norm = (v) => String(v || '').trim().toLowerCase();

  let hit = parts.find(p => norm(p.pos) === q) ||
            parts.find(p => norm(p.des) === q) ||
            parts.find(p => norm(p.name) === q) ||
            parts.find(p => norm(p.id) === q) ||
            parts.find(p => norm(p.pos).startsWith(q)) ||
            parts.find(p => norm(p.pos).includes(q)) ||
            parts.find(p => norm(p.des).includes(q)) ||
            parts.find(p => norm(p.name).includes(q));

  if (!hit) {
    if (__find.panel) {
      const msg = __find.panel.querySelector('#find_msg');
      if (msg) { msg.textContent = 'Не найдено: ' + query; msg.style.color = '#ff9a9a'; }
    }
    console.warn('[find] деталь не найдена:', query);
    return;
  }

  /* полупрозрачный режим — чтобы подсветку и внутренности было видно.
     Запоминаем, что включили его МЫ: при закрытии поиска вернём как было. */
  if (!__alpha.on) {
    __find.alphaWasOn = false;
    if (typeof toggleAlpha === 'function') {
      try { toggleAlpha(); } catch (eAl) {}
    }
  } else if (__find.alphaWasOn === undefined) {
    __find.alphaWasOn = true;
  }

  const label = hit.pos || hit.des || hit.name || hit.id;
  __highlightPart(hit.obj, label);

  if (__find.panel) {
    const msg = __find.panel.querySelector('#find_msg');
    if (msg) { msg.textContent = 'Найдено: ' + (hit.name || hit.id) + (hit.pos ? ' — ' + hit.pos : ''); msg.style.color = '#fff'; }
  }
  console.log('[find]', hit.pos || '-', '|', hit.name, '|', hit.des);
}

function toggleFindPanel() {
  if (!__find.panel) {
    const p = document.createElement('div');
    p.id = 'find_panel';
    p.style.cssText = 'position:fixed;left:50%;top:12px;transform:translateX(-50%);z-index:40;' +
      'display:none;align-items:center;gap:8px;padding:8px 12px;border-radius:6px;' +
      'background:rgba(30,30,30,.55);backdrop-filter:blur(10px);color:#fff;font:400 13px system-ui,sans-serif';

    const title = document.createElement('span');
    title.textContent = 'Позиция';
    title.style.cssText = 'opacity:.75';

    const input = document.createElement('input');
    input.id = 'find_input';
    input.type = 'text';
    input.placeholder = 'например 12';
    input.style.cssText = 'width:110px;padding:4px 6px;border-radius:4px;border:1px solid rgba(255,255,255,.25);' +
      'background:rgba(255,255,255,.08);color:#fff;outline:none';

    const btn = document.createElement('button');
    btn.textContent = 'Найти';
    btn.style.cssText = 'padding:4px 12px;border-radius:4px;border:0;cursor:pointer;' +
      'background:#E3BD33;color:#222;font-weight:600';

    const msg = document.createElement('span');
    msg.id = 'find_msg';
    msg.style.cssText = 'margin-left:6px;opacity:.9;max-width:340px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap';

    const go = () => __doFindPart(input.value);
    btn.addEventListener('click', go);
    input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { go(); } });

    p.appendChild(title); p.appendChild(input); p.appendChild(btn); p.appendChild(msg);
    document.body.appendChild(p);
    __find.panel = p;
    __find.input = input;
  }

  const shown = __find.panel.style.display === 'flex';
  if (shown) {
    __find.panel.style.display = 'none';
    __clearFindHighlight();

    /* Возвращаем всё назад: если полупрозрачность включили МЫ — выключаем её.
       Если она была включена до поиска, оставляем как было. */
    if (__find.alphaWasOn === false && __alpha.on && typeof toggleAlpha === 'function') {
      try { toggleAlpha(); } catch (eAl2) {}
    }
    __find.alphaWasOn = undefined;

    const msg = __find.panel.querySelector('#find_msg');
    if (msg) { msg.textContent = ''; }
    const inp = __find.panel.querySelector('#find_input');
    if (inp) { inp.value = ''; }
    document.getElementById('mnu_find').classList.remove('selected');
  } else {
    __find.panel.style.display = 'flex';
    document.getElementById('mnu_find').classList.add('selected');
    try { __find.input.focus(); __find.input.select(); } catch (eF) {}
  }
}

// Использование
init();
setupBloom();
const containerEl = document.getElementById('container');
const model_file = containerEl ? containerEl.dataset.modelFile : undefined;
if (model_file) {
  loadModelFromServer(model_file);
}

//меню
whenReady(function() {
  document.querySelector('.menu-toggle').addEventListener('click', function() {
      this.classList.toggle('active');
      
      // Закрытие при клике вне меню
      if (this.classList.contains('active')) {
          setTimeout(() => {
              document.addEventListener('click', closeMenuOutside);
          }, 10);
      } else {
          document.removeEventListener('click', closeMenuOutside);
      }
  });
  /* Часть пунктов меню может отсутствовать в шаблоне (например mnu_light
     закомментирован). Раньше обращение к null обрывало всю инициализацию,
     и не подключались AR-кнопка и верхняя панель. */
  function onMenuClick(id, fn) {
    const el = document.getElementById(id);
    if (el) el.addEventListener('click', fn);
    else console.warn('[menu] нет элемента ' + id + ' — пункт пропущен');
  }

  onMenuClick('mnu_find', toggleFindPanel);
  onMenuClick('mnu_flat', toggleFlatMaterial);
  onMenuClick('mnu_rg', toggleMaterial);
  onMenuClick('mnu_wf', toggleWireframe);
  onMenuClick('mnu_wire2', toggleEdges);
  onMenuClick('mnu_alpha', toggleAlpha);
  onMenuClick('mnu_dk', toggleBack);
  onMenuClick('mnu_inf', showModelInfo);
  onMenuClick('mnu_jpg', takeHighQualityScreenshotWhite);
  onMenuClick('mnu_faces', toggleFaces);
  onMenuClick('mnu_fasad', toggleFaces);
  onMenuClick('mnu_rot', toggleAutoRotate);
  onMenuClick('ar_button', clickARButton);
  onMenuClick('mnu_AR', clickARButton);
  /* «Свет»: видимость включает initBasisExtras (только если свет есть в модели),
     обработчик работает через уже настроенную подсветку. */
  onMenuClick('mnu_light', () => {
    if (typeof window.__toggleLedLights === 'function') { window.__toggleLedLights(); }
  });

  try { initARButton(); } catch (e) { console.warn('[AR] инициализация:', e.message); }
  try { initTopPanel(); } catch (e) { console.warn('[topPanel] инициализация:', e.message); }
});

async function takeHighQualityScreenshotWhite() {
  //document.getElementById('mnu_jpg').classList.add('selected');
  // И даем браузеру шанс обновиться
  await refreshUI();
  // Сохраняем текущий фон
  const originalBackground = scene.background;
  const originalClearColor = renderer.getClearColor(new THREE.Color());
  const originalClearAlpha = renderer.getClearAlpha();

  // Устанавливаем белый фон для скриншота
  scene.background = new THREE.Color(0xeeeeec);
  renderer.setClearColor(0xeeeeec, 1);

  // Увеличиваем разрешение
  const originalSize = {
      width: renderer.getSize(new THREE.Vector2()).width,
      height: renderer.getSize(new THREE.Vector2()).height
  };

  const scaleFactor = 2;
  renderer.setSize(originalSize.width * scaleFactor, originalSize.height * scaleFactor);
  __resizeBloom(originalSize.width * scaleFactor, originalSize.height * scaleFactor);
  renderScene();

  // Создаем скриншот
  const link = document.createElement('a');
  link.download = 'screenshot.jpg';
  link.href = renderer.domElement.toDataURL('image/jpeg', 0.95);
  link.click();

  // Восстанавливаем размер и оригинальные настройки
  renderer.setSize(originalSize.width, originalSize.height);
  __resizeBloom(originalSize.width, originalSize.height);
  scene.background = originalBackground;
  renderer.setClearColor(originalClearColor, originalClearAlpha);
  renderScene();
  setTimeout(()=>document.getElementById('mnu_jpg').classList.remove('selected'), 500);
}

function refreshUI() {
  return new Promise(resolve => {
    document.getElementById('mnu_jpg').classList.add('selected');
    // И даем браузеру шанс обновиться
    setTimeout(resolve, 0);
  });
}

function closeMenuOutside(e) {
    const menu = document.querySelector('.menu-container');
    if (!menu.contains(e.target)) {
        document.querySelector('.menu-toggle').classList.remove('active');
        document.removeEventListener('click', closeMenuOutside);
    }
}

function showModelInfo() {
  isInfo = !isInfo;
  if (isInfo) {
    if (!isStats) {
      isStats = true;
      const stats = analyzeModel(model);
      const materialString = stats.materials.join(', ');
      document.getElementById('info').innerHTML += ` 
      <div class = "info-panel">Количество полигонов: ${stats.polygonCount}</div>
      <div class = "info-panel">Материалов: ${stats.materialCount}</div>
      <div class = "info-panel">Материалы: ${materialString}</div>`;
    }
    document.getElementById('info').style.display = 'flex' ;
    document.getElementById('mnu_inf').classList.add('selected');
  } else {
    document.getElementById('info').style.display = 'none';
    document.getElementById('mnu_inf').classList.remove('selected');	  
  }
}


function setXRayMode(enable = true, patterns = ['Fasad1','Fasad2','Fasad3']) {
  model.traverse(child => {
    if (child.isMesh && child.material) {
      const materials = Array.isArray(child.material) ? child.material : [child.material];
      materials.forEach(mat => {
        // Проверяем несколько паттернов
        const shouldApplyXRay = patterns.some(pattern => 
          mat.name && mat.name.includes(pattern)
        ) || mat.userData.fasade == 1;
        
        if (!enable) {
          // Восстановление для всех материалов
          if (mat.userData._oldOpacity !== undefined) mat.opacity = mat.userData._oldOpacity;
          if (mat.userData._oldTransparent !== undefined) mat.transparent = mat.userData._oldTransparent;
          if (mat.userData._oldDepthWrite !== undefined) mat.depthWrite = mat.userData._oldDepthWrite;
          if (mat.userData._oldBlending !== undefined) mat.blending = mat.userData._oldBlending;
          mat.needsUpdate = true;
        } 
        else if (shouldApplyXRay) {
          // Применение X-Ray только к соответствующим материалам
          if (mat.userData._oldOpacity === undefined) mat.userData._oldOpacity = mat.opacity;
          if (mat.userData._oldTransparent === undefined) mat.userData._oldTransparent = mat.transparent;
          if (mat.userData._oldDepthWrite === undefined) mat.userData._oldDepthWrite = mat.depthWrite;
          if (mat.userData._oldBlending === undefined) mat.userData._oldBlending = mat.blending;
          
          mat.transparent = true;
          mat.opacity = 0.2;
          mat.depthWrite = false;
          //mat.blending = THREE.NormalBlending
          mat.depthTest = true;
          mat.alphaTest = 0.1;
          //mat.premultipliedAlpha = true;
          mat.needsUpdate = true;
          
        }
      });
    }
  });
}

function toggleAutoRotate() {
  isAutorotate = !isAutorotate;
  if (isAutorotate) {    
    document.getElementById('mnu_rot').classList.add('selected');
  } else {

    document.getElementById('mnu_rot').classList.remove('selected');
  }
  controls.autoRotate = isAutorotate;
} 

function toggleBack() {
  isDark = !isDark;
  if (isDark) {
      document.getElementById('container').classList.add('dark');
      document.getElementById('mnu_dk').classList.add('selected');
  } else {
      document.getElementById('container').classList.remove('dark');
      document.getElementById('mnu_dk').classList.remove('selected');
  }
} 

function analyzeModel(model) {
  let polyCount = 0;
  const materials = new Set();
  model.traverse((child) => {
    if (child.isMesh) {
        const geometry = child.geometry;
        if (geometry.index) {
            polyCount += geometry.index.count / 3 
        } else {
            polyCount += geometry.attributes.position.count / 3 
        }
        if (child.material) {
            materials.add(child.material);
        }
    }
  });
  return {
    polygonCount: polyCount,
    materialCount: materials.size,
    materials: Array.from(materials).map(m => m.name || 'unnamed-material')
  }
}


//дополненная реальность
function isARSupported() {
  const userAgent = navigator.userAgent;
  
  // Проверяем iOS версии (AR доступно с iOS 12+)
  const iosVersion = userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
  if (iosVersion && parseInt(iosVersion[1]) < 12) {
    return false;
  }
  
  // Основные проверки
  const checks = {
    isIOS: /iPad|iPhone|iPod/.test(userAgent),
    isSafari: /Safari/.test(userAgent) && !/Chrome|CriOS/.test(userAgent),
    hasWebGL: (() => {
      try {
        const canvas = document.createElement('canvas');
        return !!(window.WebGLRenderingContext && 
                 (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
      } catch (e) {
        return false;
      }
    })(),
    supportsAR: (() => {
      const a = document.createElement('a');
      return a.relList && a.relList.supports && a.relList.supports('ar');
    })()
  };
  
  return (checks.isIOS && checks.isSafari && checks.hasWebGL) || checks.supportsAR;
}

function initARButton() {
  const button = document.getElementById('ar_button');
  const arkit_button = document.getElementById('AR_menu');
  const usdzLink = document.getElementById('usdz-link');

  if (isARSupported() && usdzLink.href.length>10) {
    button.classList.add('flashing');
    arkit_button.classList.remove('hidden-field')
  } else {
    button.classList.add('hidden-field');
    ;
  }
}

function clickARButton() {
  const button = document.getElementById('ar_button');
  const usdzLink = document.getElementById('usdz-link');
  
  if (isARSupported()) {
    // Программный клик по скрытой ссылке
    if (usdzLink.dataset.usdzStatus != "completed") {
      showAlert('Файл еще не готов, попробуйте позже.');
      return false;
    }
    usdzLink.click();
    // Добавляем вибрацию на iOS (опционально)
    button.addEventListener('touchstart', () => {
      if (navigator.vibrate) {
        navigator.vibrate(10);
      }
    });
    console.log('AR поддерживается в этом браузере');
  } else {
    showAlert('AR не поддерживается в этом браузере',"danger");
  }

}

function detectBrowserStrict() {
  const ua = navigator.userAgent;
  
  // 1. Safari (нативный, не другие браузеры на iOS)
  if (/^((?!chrome|android).)*safari/i.test(ua) && 
      !/crios/i.test(ua) && 
      !/edg/i.test(ua)) {
      return true;
  }
  
  // 2. Chrome на iOS
  if (/crios/i.test(ua) || 
      (/chrome/i.test(ua) && /iphone|ipad|ipod/i.test(ua))) {
      return false;
  }
  
  // 3. Chrome на Android
  if (/chrome/i.test(ua) && 
      /android/i.test(ua) && 
      !/edg/i.test(ua)) {
      return true;
  }
  
  // 4. Все остальные
  return false;
}

/* Показывать ли подсказку «Смахните вверх…».
   Раньше смотрели только на UA (список выше) — на планшетах, в Firefox
   Mobile и в «Desktop site» она не появлялась. Теперь достаточно тач-экрана
   и небольшого окна; UA-проверка осталась как запасной вариант. */
function isTouchViewer() {
  const touch = (navigator.maxTouchPoints || 0) > 0 ||
                'ontouchstart' in window ||
                (window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  const small = Math.min(window.innerWidth || 0, window.innerHeight || 0) <= 900;
  return (touch && small) || detectBrowserStrict();
}

function initTopPanel() {
  /* id в разметке мог не дойти (старые шаблоны) — ищем и по классу */
  const topPanel = document.getElementById('top-panel') ||
                   document.querySelector('.top-panel');
  if (!topPanel) return;
  if (isTouchViewer()) {
    topPanel.classList.remove('hidden-field');
    /* кнопки вверху не должны налезать на подсказку */
    //document.body.classList.add('has-top-panel');
    console.log('[topPanel] подсказка показана (мобильный режим)');
  } else {
    topPanel.classList.add('hidden-field');
    //document.body.classList.remove('has-top-panel');
  }
}

/* --- экспорт в window для inline-обработчиков --- */
/* webpack оборачивает файл в функцию, поэтому объявления верхнего уровня
   не становятся глобальными, и onclick="имя()" в шаблонах падал с
   «is not defined». Экспортируем явно. */
try { window.__addLabel = __addLabel; } catch (e) {}
try { window.__arrow = __arrow; } catch (e) {}
try { window.__buildDims = __buildDims; } catch (e) {}
try { window.__buildEdges = __buildEdges; } catch (e) {}
try { window.__buildWireframe = __buildWireframe; } catch (e) {}
try { window.__clearEdges = __clearEdges; } catch (e) {}
try { window.__clearFindHighlight = __clearFindHighlight; } catch (e) {}
try { window.__clearWireframe = __clearWireframe; } catch (e) {}
try { window.__doFindPart = __doFindPart; } catch (e) {}
try { window.__edgesDiagnostics = __edgesDiagnostics; } catch (e) {}
try { window.__findParts = __findParts; } catch (e) {}
try { window.__fmtMm = __fmtMm; } catch (e) {}
try { window.__hideOutlines = __hideOutlines; } catch (e) {}
try { window.__highlightPart = __highlightPart; } catch (e) {}
try { window.__panelMeshes = __panelMeshes; } catch (e) {}
try { window.__seg = __seg; } catch (e) {}
try { window.__setWireMode = __setWireMode; } catch (e) {}
try { window.__surfaceBias = __surfaceBias; } catch (e) {}
try { window.__syncWireMenu = __syncWireMenu; } catch (e) {}
try { window.__updateDims = __updateDims; } catch (e) {}
try { window.analyzeModel = analyzeModel; } catch (e) {}
try { window.animate = animate; } catch (e) {}
try { window.clickARButton = clickARButton; } catch (e) {}
try { window.clockDelta = clockDelta; } catch (e) {}
try { window.closeMenuOutside = closeMenuOutside; } catch (e) {}
try { window.detectBrowserStrict = detectBrowserStrict; } catch (e) {}
try { window.fitCameraToObject = fitCameraToObject; } catch (e) {}
try { window.init = init; } catch (e) {}
try { window.initARButton = initARButton; } catch (e) {}
try { window.initBasisExtras = initBasisExtras; } catch (e) {}
try { window.initDimensionsButton = initDimensionsButton; } catch (e) {}
try { window.initTopPanel = initTopPanel; } catch (e) {}
try { window.isARSupported = isARSupported; } catch (e) {}
try { window.refreshUI = refreshUI; } catch (e) {}
try { window.restoreDefaultLighting = restoreDefaultLighting; } catch (e) {}
try { window.setXRayMode = setXRayMode; } catch (e) {}
try { window.__facadesDebug = () => __basisFacadeNodes(); } catch (eFd) {}
try { window.showModelInfo = showModelInfo; } catch (e) {}
try { window.toggleAlpha = toggleAlpha; } catch (e) {}
try { window.toggleAutoRotate = toggleAutoRotate; } catch (e) {}
try { window.toggleBack = toggleBack; } catch (e) {}
try { window.toggleDimensions = toggleDimensions; } catch (e) {}
try { window.toggleEdges = toggleEdges; } catch (e) {}
try { window.toggleFaces = toggleFaces; } catch (e) {}
try { window.toggleFindPanel = toggleFindPanel; } catch (e) {}
try { window.toggleFlatMaterial = toggleFlatMaterial; } catch (e) {}
try { window.toggleLight = toggleLight; } catch (e) {}
try { window.toggleLight2 = toggleLight2; } catch (e) {}
try { window.toggleMaterial = toggleMaterial; } catch (e) {}
try { window.toggleRoom = toggleRoom; } catch (e) {}
try { window.setRoomAnchor = setRoomAnchor; } catch (e) {}
try { window.clearRoom = __clearRoom; } catch (e) {}
try { window.isRoomOn = function () { return !!__room.on; }; } catch (e) {}
/* Диагностика для локальных проверок: где стоит стена и где изделие. */
try {
  window.roomDebug = function () {
    if (!__room.group || !model) { return null; }
    const wall = __room.group.getObjectByName('room-wall');
    const box = new THREE.Box3().setFromObject(model);
    return {
      anchor: __room.anchor,
      wallX: wall ? wall.position.x : null,
      wallLeft: wall ? wall.position.x - 5 : null,
      wallRight: wall ? wall.position.x + 5 : null,
      modelMinX: box.min.x,
      modelMaxX: box.max.x
    };
  };
} catch (e) {}
try { window.toggleWireframe = toggleWireframe; } catch (e) {}
try { window.toggleXRayLighting = toggleXRayLighting; } catch (e) {}
